export const medicalSpecialtyOptions = [
  {
    label: "Immunology",
    value: "IM",
    regCodes: [
      "866.5880-Transferrin immunological test system.",
      "866.5550-Immunoglobulin (light chain specific) immunological test system.",
      "866.5540-Immunoglobulin G (Fd fragment specific) immunological test system.",
      "866.5530-Immunoglobulin G (Fc fragment specific) immunological test system.",
      "866.5425-Alpha-2-glycoproteins immunological test system.",
      "866.5240-Complement components immunological test system.",
      "866.5250-Complement C1 inhibitor (inactivator) immunological test system.",
      "866.5120-Antismooth muscle antibody immunological test system.",
      "866.5340-Ferritin immunological test system.",
      "866.5110-Antiparietal antibody immunological test system.",
      "866.5660-Multiple autoantibodies immunological test system.",
      "866.5090-Antimitochondrial antibody immunological test system.",
      "866.5520-Immunoglobulin G (Fab fragment specific) immunological test system.",
      "866.5040-Albumin immunological test system.",
      "866.5270-C-reactive protein immunological test system.",
      "866.5160-Beta-globulin immunological test system.",
      "866.5400-Alpha-globulin immunological test system.",
      "866.5210-Ceruloplasmin immunological test system.",
      "866.5870-Thyroid autoantibody immunological test system.",
      "862.2570-Instrumentation for clinical multiplex test systems.",
      "864.5220-Automated differential cell counter.",
      "866.5510-Immunoglobulins A, G, M, D, and E immunological test system.",
      "866.5890-Inter-alpha trypsin inhibitor immunological test system.",
      "866.5150-Bence-Jones proteins immunological test system.",
      "866.5490-Hemopexin immunological test system.",
      "866.5765-Retinol-binding protein immunological test system.",
      "866.5460-Haptoglobin immunological test system.",
      "866.5260-Complement C3b inactivator immunological test system.",
      "866.5380-Free secretory component immunological test system.",
      "866.5360-Cohn fraction IV immunological test system.",
      "866.5470-Hemoglobin immunological test system.",
      "866.5350-Fibrinopeptide A immunological test system.",
      "866.5440-Beta-2-glycoprotein III immunological test system.",
      "866.5430-Beta-2-glycoprotein I immunological test system.",
      "866.5680-Myoglobin immunological test system.",
      "866.5060-Prealbumin immunological test system.",
      "866.5620-Alpha-2-macroglobulin immunological test system.",
      "866.5570-Lactoferrin immunological test system.",
      "866.5130-Alpha-1-antitrypsin immunological test system.",
      "866.5590-Lipoprotein X immunological test system.",
      "866.5420-Alpha-1-glycoproteins immunological test system.",
      "866.5580-Alpha-1-lipoprotein immunological test system.",
      "866.5560-Lactic dehydrogenase immunological test system.",
      "866.5600-Low-density lipoprotein immunological test system.",
      "866.5080-Alpha-1-antichymotrypsin immunological test system.",
      "866.5860-Total spinal fluid immunological test system.",
      "866.5800-Seminal fluid (sperm) immunological test system.",
      "866.5220-Cohn fraction II immunological test system.",
      "866.5170-Breast milk immunological test system.",
      "866.5230-Colostrum immunological test system.",
      "866.5500-Hypersensitivity pneumonitis immunological test system.",
      "866.5065-Human allotypic marker immunological test system.",
      "866.5750-Radioallergosorbent (RAST) immunological test system.",
      "866.5820-Systemic lupus erythematosus immunological test system.",
      "866.4100-Complement reagent.",
      "866.5100-Antinuclear antibody immunological test system.",
      "866.5775-Rheumatoid factor immunological test system.",
      "866.6010-Tumor-associated antigen immunological test system.",
      "866.5630-Beta-2-microglobulin immunological test system.",
      "866.5320-Properdin factor B immunological test system.",
      "866.4600-Ouchterlony agar plate.",
      "866.4800-Radial immunodiffusion plate.",
      "866.4900-Support gel.",
      "866.4500-Immunoelectrophoresis equipment.",
      "866.4520-Immunofluorometer equipment.",
      "866.4540-Immunonephelometer equipment.",
      "866.4830-Rocket immunoelectrophoresis equipment.",
      "866.5370-Cohn fraction V immunological test system.",
      "866.6030-AFP-L3% immunological test system.",
      "866.5785-Anti-Saccharomyces cerevisiae (S. cerevisiae) antibody (ASCA) test systems.",
      "866.3950-In vitro human immunodeficiency virus (HIV) drug resistance genotype assay.",
      "866.3950-In vitro human immunodeficiency virus (HIV) drug resistance genotype assay.",
      "866.5180-Fecal calprotectin immunological test system.",
      "866.5760-Tryptase test system.",
      "866.5970",
      "866.5670-Zinc transporter 8 autoantibody immunological test system.",
      "866.4750-Automated indirect immunofluorescence microscope and software-assisted system.",
      "866.5930-Newborn screening test for severe combined immunodeficiency disorder (SCID).",
      "866.5665-Aquaporin-4 autoantibody immunological test system.",
      "866.5950-Genetic health risk assessment system.",
      "866.5830-Brain trauma assessment test.",
      "866.5840",
      "866.5960-Human leukocyte antigen typing companion diagnostic test.",
      "866.3830-Treponema pallidum treponemal test reagents.",
      "866.2560-Microbial growth monitor.",
      "866.5910-Quality control material for cystic fibrosis nucleic acid assays.",
      "866.5780",
      "866.6050-Ovarian adnexal mass assessment score test system.",
      "864.4010-General purpose reagent.",
      "862.3100-Amphetamine test system.",
      "(blank)",
    ],
  },
  {
    label: "Ear, Nose, and Throat",
    value: "EN",
    regCodes: [
      "874.4420-Ear, nose, and throat manual surgical instrument.",
      "874.4250-Ear, nose, and throat electric or pneumatic surgical drill.",
      "868.5800-Tracheostomy tube and tube cuff.",
      "872.5570-Intraoral devices for snoring and intraoral devices for snoring and obstructive sleep apnea.",
      "872.3275-Dental cement.",
      "872.6510-Oral irrigation unit.",
      "874.4680-Bronchoscope (flexible or rigid) and accessories.",
      "874.4100-Epistaxis balloon.",
      "874.4175-Nasopharyngeal catheter.",
      "874.4760-Nasopharyngoscope (flexible or rigid) and accessories.",
      "874.4710-Esophagoscope (flexible or rigid) and accessories.",
      "874.3320-Group hearing aid or group auditory trainer.",
      "874.5220-Ear, nose, and throat drug administration device.",
      "874.5800-External nasal splint.",
      "874.4350-Ear, nose, and throat fiberoptic light source and carrier.",
      "874.4140-Ear, nose, and throat bur.",
      "874.4750-Laryngostroboscope.",
      "874.4770-Otoscope.",
      "874.3300-Air-conduction hearing aid.",
      "874.3375-Battery-powered artificial larynx.",
      "874.3620-Ear, nose, and throat synthetic polymer material.",
      "874.3760-Sacculotomy tack (Cody tack)",
      "874.3820-Endolymphatic shunt.",
      "874.3495-Total ossicular replacement prosthesis.",
      "874.3450-Partial ossicular replacement prosthesis.",
      "874.3430-Middle ear mold.",
      "874.3880-Tympanostomy tube.",
      "874.5300-Ear, nose, and throat examination and treatment unit.",
      "874.1925-Toynbee diagnostic tube.",
      "874.1500-Gustometer.",
      "874.1820-Surgical nerve stimulator/locator.",
      "874.1800-Air or water caloric stimulator.",
      "874.1070-Short increment sensitivity index (SISI) adapter.",
      "874.1120-Electronic noise generator for audiometric testing.",
      "874.1100-Earphone cushion for audiometric testing.",
      "874.3310-Hearing aid calibrator and analysis system.",
      "874.1090-Auditory impedance tester.",
      "874.1080-Audiometer calibration set.",
      "874.1060-Acoustic chamber for audiometric testing.",
      "874.4500-Ear, nose, and throat microsurgical carbon dioxide laser.",
      "874.3730-Laryngeal prosthesis (Taub design).",
      "874.1050-Audiometer.",
      "874.5350-Suction antichoke device.",
      "874.5370-Tongs antichoke device.",
      "874.4720-Mediastinoscope and accessories.",
      "874.3540-Prosthesis modification instrument for ossicular replacement surgery.",
      "874.3330-Master hearing aid.",
      "874.3400-Tinnitus masker.",
      "874.1325-Electroglottograph.",
      "874.3850-Endolymphatic shunt tube with valve.",
      "874.5550-Powered nasal irrigator.",
      "874.3930-Tympanostomy tube with semipermeable membrane.",
      "874.5840-Antistammering device.",
      "874.4490-Argon laser for otology, rhinology, and laryngology.",
      "874.3900-Nasal dilator.",
      "874.3302-Bone-conduction hearing aid.",
      "874.4780-Intranasal splint.",
      "874.4800-Bone particle collector.",
      "874.3950-Transcutaneous air conduction hearing aid system.",
      "874.1600-Olfactory test device.",
      "874.4450-Powered insertion system for a cochlear implant electrode array.",
      "874.3305-Wireless air-conduction hearing aid.",
      "874.3340-Active implantable bone conduction hearing system.",
      "874.5900-External upper esophageal sphincter compression device.",
      "874.3315-Tympanic membrane contact hearing aid.",
      "874.4180-Eustachian tube balloon dilation system.",
      "874.3325-Self-fitting air-conduction hearing aid.",
      "874.6000",
      "874.5950",
      "874.3410",
      "874.4460",
      "874.6010",
      "874.3335",
      "880.5045-Medical recirculating air cleaner.",
      "880.6960-Irrigating syringe.",
      "882.4560-Stereotaxic instrument.",
      "882.4565",
      "892.1560-Ultrasonic pulsed echo imaging system.",
      "892.1550-Ultrasonic pulsed doppler imaging system.",
      "892.2050-Medical image management and processing system.",
      "878.4750-Implantable staple.",
      "(blank)",
    ],
  },
  {
    label: "Obstetrical and Gynecological",
    value: "OB",
    regCodes: [
      "884.4250-Expandable cervical dilator.",
      "884.5380-Contraceptive tubal occlusion device (TOD) and introducer.",
      "884.4530-Obstetric-gynecologic specialized manual instrument.",
      "884.4500-Obstetric fetal destructive instrument.",
      "884.4520-Obstetric-gynecologic general manual instrument.",
      "862.1550-Urinary pH (nonquantitative) test system.",
      "870.3300-Vascular embolization device.",
      "870.2770-Impedance plethysmograph.",
      "876.5980-Gastrointestinal tube and accessories.",
      "876.1075-Gastroenterology-urology biopsy instrument.",
      "884.4400-Obstetric forceps.",
      "884.4340-Fetal vacuum extractor.",
      "884.4900-Obstetric table and accessories.",
      "884.5250-Cervical cap.",
      "884.5360-Contraceptive intrauterine device (IUD) and introducer.",
      "884.5350-Contraceptive diaphragm and accessories.",
      "884.3900-Vaginal stent.",
      "884.4260-Hygroscopic Laminaria cervical dilator.",
      "884.5470-Unscented menstrual tampon.",
      "884.5920-Vaginal insufflator.",
      "884.5900-Therapeutic vaginal douche apparatus.",
      "884.5100-Obstetric anesthesia set.",
      "884.5225-Abdominal decompression chamber.",
      "884.2660-Fetal ultrasonic monitor and accessories.",
      "884.2225-Obstetric-gynecologic ultrasonic imager.",
      "884.2050-Obstetric data analyzer.",
      "884.1300-Uterotubal carbon dioxide insufflator and accessories.",
      "884.1720-Gynecologic laparoscope and accessories.",
      "884.1640-Culdoscope and accessories.",
      "884.1630-Colposcope.",
      "884.1660-Transcervical endoscope (amnioscope) and accessories.",
      "884.1600-Transabdominal amnioscope (fetoscope) and accessories.",
      "884.1050-Endocervical aspirator.",
      "884.1185-Endometrial washer.",
      "884.1100-Endometrial brush.",
      "884.1060-Endometrial aspirator.",
      "884.4160-Unipolar endoscopic coagulator-cutter and accessories.",
      "884.3650-Fallopian tube prosthesis.",
      "884.3200-Cervical drain.",
      "884.2720-External uterine contraction monitor and accessories.",
      "884.2700-Intrauterine pressure monitor and accessories.",
      "884.2640-Fetal phonocardiographic monitor and accessories.",
      "884.5070-Vacuum abortion system.",
      "884.4120-Gynecologic electrocautery and accessories.",
      "884.2960-Obstetric ultrasonic transducer and accessories.",
      "884.2740-Perinatal monitoring system and accessories.",
      "884.2900-Fetal stethoscope.",
      "884.2620-Fetal electroencephalographic monitor.",
      "884.2675-Fetal scalp circular (spiral) electrode and applicator.",
      "884.1560-Fetal blood sampler.",
      "884.5160-Powered breast pump.",
      "884.5150-Nonpowered breast pump.",
      "884.5390-Perineal heater.",
      "884.5435-Unscented menstrual pad.",
      "884.5400-Menstrual cup.",
      "884.4270-Vibratory cervical dilators.",
      "884.1175-Endometrial suction curette and accessories.",
      "884.5425-Scented or scented deodorized menstrual pad.",
      "884.5050-Metreurynter-balloon abortion system.",
      "884.4550-Gynecologic surgical laser.",
      "884.3575-Vaginal pessary.",
      "884.1730-Laparoscopic insufflator.",
      "884.1700-Hysteroscopic insufflator.",
      "884.1690-Hysteroscope and accessories.",
      "884.5940-Powered vaginal muscle stimulator for therapeutic use.",
      "884.5460-Scented or scented deodorized menstrual tampon.",
      "884.4100-Endoscopic electrocautery and accessories.",
      "884.4150-Bipolar endoscopic coagulator-cutter and accessories.",
      "884.1550-Amniotic fluid sampler (amniocentesis tray).",
      "884.2685-Fetal scalp clip electrode and applicator.",
      "884.5300-Condom.",
      "884.2600-Fetal cardiac monitor.",
      "884.5960-Genital vibrator for therapeutic use.",
      "884.1040-Viscometer for cervical mucus.",
      "884.2730-Home uterine activity monitor.",
      "884.5310-Condom with spermicidal lubricant.",
      "884.5320-Glans sheath.",
      "884.5340-Single-use internal condom.",
      "884.6100-Assisted reproduction needles.",
      "884.6110-Assisted reproduction catheters.",
      "884.6120-Assisted reproduction accessories.",
      "884.6130-Assisted reproduction microtools.",
      "884.6140-Assisted reproduction micropipette fabrication instruments.",
      "884.6150-Assisted reproduction micromanipulators and microinjectors.",
      "884.6160-Assisted reproduction labware.",
      "884.6180-Reproductive media and supplements.",
      "884.6200-Assisted reproduction laser system.",
      "884.6170-Assisted reproduction water and water purification systems.",
      "884.6190-Assisted reproductive microscopes and microscope accessories.",
      "884.5970-Clitoral engorgement device.",
      "884.2990-Breast lesion documentation system.",
      "884.5330-Multiple-use female condom.",
      "884.5980-Surgical mesh for transvaginal pelvic organ prolapse repair.",
      "884.6165-Intravaginal culture system.",
      "884.6195-Assisted Reproduction Embryo Image Assessment System.",
      "884.5200-Hemorrhoid prevention pressure wedge.",
      "884.1710-Closed loop hysteroscopic insufflator with cutter-coagulator.",
      "884.4050-Gynecologic laparoscopic power morcellation containment system.",
      "884.5210-Pressure wedge for the reduction of cesarean delivery.",
      "878.3300-Surgical mesh.",
      "884.4350-Fetal head elevator.",
      "884.4910-Specialized surgical instrumentation for use with urogynecologic surgical mesh.",
      "884.5370-Software application for contraception.",
      "884.5305",
      "884.2800-Computerized Labor Monitoring System.",
      "890.3490-Truncal orthosis.",
      "(blank)",
    ],
  },
  {
    label: "Pathology",
    value: "PA",
    regCodes: [
      "864.1850-Dye and chemical solution stains.",
      "864.7675-Leukocyte peroxidase test.",
      "864.2875-Balanced salt solutions or formulations.",
      "864.2260-Chromosome culture kit.",
      "864.2280-Cultured animal and human cells.",
      "864.2800-Animal and human sera.",
      "864.2220-Synthetic cell and tissue culture media and components.",
      "864.2360-Mycoplasma detection media and components.",
      "864.2240-Cell and tissue culture supplies and equipment.",
      "864.5260-Automated cell-locating device.",
      "864.1860-Immunohistochemistry reagents and kits.",
      "864.7280-Factor V Leiden DNA mutation detection systems.",
      "864.1870-Early growth response 1 (EGR1) gene fluorescence in-situ hybridization (FISH) test system for specimen characterization.",
      "864.9650-Quality control kit for blood banking reagents.",
      "864.3010-Tissue processing equipment.",
      "866.6110",
      "866.5510-Immunoglobulins A, G, M, D, and E immunological test system.",
      "866.5550-Immunoglobulin (light chain specific) immunological test system.",
      "866.5065-Human allotypic marker immunological test system.",
      "866.6020-Immunomagnetic circulating cancer cell selection and enumeration system.",
      "866.4700-Automated fluorescence in situ hybridization (FISH) enumeration systems.",
      "866.4070-RNA Preanalytical Systems.",
      "866.5900-Cystic fibrosis transmembrane conductance regulator (CFTR) gene mutation detection system.",
      "866.6040-Gene expression profiling test system for breast cancer prognosis.",
      "866.6010-Tumor-associated antigen immunological test system.",
      "866.5920",
      "866.5940-Autosomal recessive carrier screening gene mutation detection system.",
      "864.1866-Lynch syndrome test systems.",
      "864.3875-Automated tissue processor.",
      "866.6060-BCR-ABL quantitation test.",
      "866.6070",
      "866.6090",
      "864.1880",
      "866.6000-Whole exome sequencing constituent device.",
      "864.4010-General purpose reagent.",
      "864.4400-Enzyme preparations.",
      "864.3600-Microscopes and accessories.",
      "864.3300-Cytocentrifuge.",
      "864.3250-Specimen transport and storage container.",
      "864.3800-Automated slide stainer.",
      "864.3400-Device for sealing microsections.",
      "864.1865-Cervical intraepithelial neoplasia (CIN) test system.",
      "864.3700-Whole slide imaging system.",
      "866.6080-Next generation sequencing based tumor profiling test.",
      "866.6100",
      "864.3750-Software algorithm device to assist users in digital pathology.",
      "866.6095",
      "864.3900",
      "866.6085",
      "(blank)",
    ],
  },
  {
    label: "Orthopedic",
    value: "OR",
    regCodes: [
      "888.3030-Single/multiple component metallic bone fixation appliances and accessories.",
      "888.3010-Bone fixation cerclage.",
      "888.4540-Orthopedic manual surgical instrument.",
      "888.3160-Elbow joint metal/polymer semi-constrained cemented prosthesis.",
      "888.3150-Elbow joint metal/polymer constrained cemented prosthesis.",
      "888.3360-Hip joint femoral (hemi-hip) metallic cemented or uncemented prosthesis.",
      "888.3380-Hip joint femoral (hemi-hip) trunnion-bearing metal/polyacetal cemented prosthesis.",
      "888.3350-Hip joint metal/polymer semi-constrained cemented prosthesis.",
      "888.3320-Hip joint metal/metal semi-constrained, with a cemented acetabular component, prosthesis.",
      "882.4560-Stereotaxic instrument.",
      "888.3060-Spinal intervertebral body fixation orthosis.",
      "888.1100-Arthroscope.",
      "888.3530-Knee joint femorotibial metal/polymer semi-constrained cemented prosthesis.",
      "888.3480-Knee joint femorotibial metallic constrained cemented prosthesis.",
      "888.3570-Knee joint femoral (hemi-knee) metallic uncemented prosthesis.",
      "888.3020-Intramedullary fixation rod.",
      "888.3690-Shoulder joint humeral (hemi-shoulder) metallic uncemented prosthesis.",
      "888.3590-Knee joint tibial (hemi-knee) metallic resurfacing uncemented prosthesis.",
      "888.3110-Ankle joint metal/polymer semi-constrained cemented prosthesis.",
      "888.5890-Noninvasive traction component.",
      "888.3520-Knee joint femorotibial metal/polymer non-constrained cemented prosthesis.",
      "888.3580-Knee joint patellar (hemi-knee) metallic resurfacing uncemented prosthesis.",
      "888.4600-Protractor for clinical use.",
      "888.4300-Depth gauge for clinical use.",
      "888.3040-Smooth or threaded metallic bone fixation fastener.",
      "888.4800-Template for clinical use.",
      "888.3025-Passive tendon prosthesis.",
      "888.3000-Bone cap.",
      "888.4580-Sonic surgical instrument and accessories/attachments.",
      "888.4220-Cement monomer vapor evacuator.",
      "888.4210-Cement mixer for clinical use.",
      "888.3560-Knee joint patellofemorotibial polymer/metal/polymer semi-constrained cemented prosthesis.",
      "888.3800-Wrist joint metal/polymer semi-constrained cemented prosthesis.",
      "888.3780-Wrist joint polymer constrained prosthesis.",
      "888.4200-Cement dispenser.",
      "888.4230-Cement ventilation tube.",
      "888.3490-Knee joint femorotibial metal/composite non-constrained cemented prosthesis.",
      "888.3340-Hip joint metal/composite semi-constrained cemented prosthesis.",
      "888.3100-Ankle joint metal/composite semi-constrained cemented prosthesis.",
      "888.3510-Knee joint femorotibial metal/polymer constrained cemented prosthesis.",
      "888.3550-Knee joint patellofemorotibial polymer/metal/metal constrained cemented prosthesis.",
      "888.3540-Knee joint patellofemoral polymer/metal semi-constrained cemented prosthesis.",
      "888.4150-Calipers for clinical use.",
      "888.3330-Hip joint metal/metal semi-constrained, with an uncemented acetabular component, prosthesis.",
      "888.3370-Hip joint (hemi-hip) acetabular metal cemented prosthesis.",
      "888.3730-Toe joint phalangeal (hemi-toe) polymer prosthesis.",
      "888.3200-Finger joint metal/metal constrained uncemented prosthesis.",
      "888.3230-Finger joint polymer constrained prosthesis.",
      "888.3220-Finger joint metal/polymer constrained cemented prosthesis.",
      "888.3720-Toe joint polymer constrained prosthesis.",
      "888.3170-Elbow joint radial (hemi-elbow) polymer prosthesis.",
      "888.3180-Elbow joint humeral (hemi-elbow) metallic uncemented prosthesis.",
      "888.3750-Wrist joint carpal lunate polymer prosthesis.",
      "888.3760-Wrist joint carpal scaphoid polymer prosthesis.",
      "888.3050-Spinal interlaminal fixation orthosis.",
      "888.3640-Shoulder joint metal/metal or metal/polymer constrained cemented prosthesis.",
      "888.3660-Shoulder joint metal/polymer semi-constrained cemented prosthesis.",
      "888.3650-Shoulder joint metal/polymer non-constrained cemented prosthesis.",
      "888.3390-Hip joint femoral (hemi-hip) metal/polymer cemented or uncemented prosthesis.",
      "888.3310-Hip joint metal/polymer constrained cemented or uncemented prosthesis.",
      "888.3400-Hip joint femoral (hemi-hip) metallic resurfacing prosthesis.",
      "888.3045-Resorbable calcium salt bone void filler device.",
      "888.3410-Hip joint metal/polymer or ceramic/polymer semiconstrained resurfacing cemented prosthesis.",
      "888.3120-Ankle joint metal/polymer non-constrained cemented prosthesis.",
      "888.3300-Hip joint metal constrained cemented or uncemented prosthesis.",
      "888.3810-Wrist joint ulnar (hemi-wrist) polymer prosthesis.",
      "888.3770-Wrist joint carpal trapezium polymer prosthesis.",
      "888.3500-Knee joint femorotibial metal/composite semi-constrained cemented prosthesis.",
      "888.3680-Shoulder joint glenoid (hemi-shoulder) metallic cemented prosthesis.",
      "888.3790-Wrist joint metal constrained cemented prosthesis.",
      "888.3210-Finger joint metal/metal constrained cemented prosthesis.",
      "888.5940-Cast component.",
      "888.5980-Manual cast application and removal instrument.",
      "888.5960-Cast removal instrument.",
      "888.3027-Polymethylmethacrylate (PMMA) bone cement.",
      "888.3358-Hip joint metal/polymer/metal semi-constrained porous-coated uncemented prosthesis.",
      "888.1520-Nonpowered goniometer.",
      "888.3080-Intervertebral body fusion device.",
      "888.3670-Shoulder joint metal/polymer/metal nonconstrained or semi-constrained porous-coated uncemented prosthesis.",
      "888.3565-Knee joint patellofemorotibial metal/polymer porous-coated uncemented prosthesis.",
      "888.3070-Thoracolumbosacral pedicle screw system.",
      "888.3075-Posterior cervical screw system.",
      "888.3535-Knee joint femorotibial (uni-compartmental) metal/polymer porous-coated uncemented prosthesis.",
      "888.3015-Bone heterograft.",
      "888.3085-Intervertebral body graft containment device.",
      "888.3043-Screw sleeve bone fixation device.",
      "888.3023-In vivo cured intramedullary fixation rod.",
      "888.4505-Orthopedic surgical instrumentation designed for osteochondral implants with press-fit fixation.",
      "888.3090-Intraoperative orthopedic strain sensor.",
      "888.1600-Bone indentation device.",
      "888.4510",
      "888.3041",
      "888.3695",
      "888.4515",
      "888.4520",
      "888.3044-Resorbable implant for anterior cruciate ligament (ACL) repair.",
      "888.3600-Implantable post-surgical kinematic measurement knee device.",
      "888.3630-Resorbable shoulder spacer.",
      "888.3046",
      "888.3610",
      "888.4560",
      "888.5895",
      "888.3071",
      "888.3900",
      "878.4820-Surgical instrument motors and accessories/attachments.",
      "878.3300-Surgical mesh.",
      "878.4800-Manual surgical instrument for general use.",
      "(blank)",
    ],
  },
  {
    label: "Toxicology",
    value: "TX",
    regCodes: [
      "862.3150-Barbiturate test system.",
      "862.3100-Amphetamine test system.",
      "862.3040-Alcohol test system.",
      "862.3580-Lysergic acid diethylamide (LSD) test system.",
      "862.3270-Codeine test system.",
      "862.3645-Neuroleptic drugs radioreceptor assay test system.",
      "862.3380-Ethosuximide test system.",
      "862.3240-Cholinesterase test system.",
      "862.3200-Clinical toxicology calibrator.",
      "862.3700-Propoxyphene test system.",
      "862.3250-Cocaine and cocaine metabolite test system.",
      "862.3350-Diphenylhydantoin test system.",
      "862.3640-Morphine test system.",
      "862.3650-Opiate test system.",
      "862.3660-Phenobarbital test system.",
      "862.3620-Methadone test system.",
      "862.3550-Lead test system.",
      "862.3280-Clinical toxicology control material.",
      "862.3680-Primidone test system.",
      "862.3830-Salicylate test system.",
      "862.1092",
      "862.1620-Progesterone test system.",
      "862.3245-Clozapine test system.",
      "862.3300-Digitoxin test system.",
      "862.2250-Gas liquid chromatography system for clinical use.",
      "862.2270-Thin-layer chromatography system for clinical use.",
      "862.2230-Chromatographic separation material for clinical use.",
      "862.2260-High pressure liquid chromatography system for clinical use.",
      "862.2860-Mass spectrometer for clinical use.",
      "862.2850-Atomic absorption spectrophotometer for clinical use.",
      "862.1235-Cyclosporine test system.",
      "862.1678-Tacrolimus test system.",
      "862.1175-Cholesterol (total) test system.",
      "862.1225-Creatinine test system.",
      "862.1300-Follicle-stimulating hormone test system.",
      "862.1450-Lactic acid test system.",
      "862.1485-Luteinizing hormone test system.",
      "862.1510-Nitrite (nonquantitative) test system.",
      "862.1705-Triglyceride test system.",
      "862.3800-Reagents for molecular diagnostic instrument test systems.",
      "862.3850-Sulfonamide test system.",
      "862.1602",
      "864.7470-Glycosylated hemoglobin assay.",
      "864.6550-Occult blood test.",
      "866.5600-Low-density lipoprotein immunological test system.",
      "862.3900-Tobramycin test system.",
      "862.3450-Gentamicin test system.",
      "862.3610-Methamphetamine test system.",
      "862.3050-Breath-alcohol test system.",
      "862.3320-Digoxin test system.",
      "862.3110-Antimony test system.",
      "862.3120-Arsenic test system.",
      "862.3600-Mercury test system.",
      "862.3560-Lithium test system.",
      "862.3220-Carbon monoxide test system.",
      "862.3170-Benzodiazepine test system.",
      "862.3520-Kanamycin test system.",
      "862.3035-Amikacin test system.",
      "862.3555-Lidocaine test system.",
      "862.3880-Theophylline test system.",
      "862.3630-Methaqualone test system.",
      "862.3030-Acetaminophen test system.",
      "862.3950-Vancomycin test system.",
      "862.3910-Tricyclic antidepressant drugs test system.",
      "862.3840-Sirolimus test system.",
      "862.3360-Drug metabolizing enzyme genotyping system.",
      "862.3652-Organophosphate test system.",
      "862.3970",
      "862.3590-Meprobamate test system.",
      "862.3460",
      "862.3115",
      "(blank)",
    ],
  },
  {
    label: "Ophthalmic",
    value: "OP",
    regCodes: [
      "886.1780-Retinoscope.",
      "886.1500-Headband mirror.",
      "886.1320-Fornixscope.",
      "886.1120-Ophthalmic camera.",
      "886.5870-Low-vision telescope.",
      "876.1500-Endoscope and accessories.",
      "880.5725-Infusion pump.",
      "886.4335-Operating headlamp.",
      "886.4445-Permanent magnet.",
      "886.1170-Color vision tester.",
      "886.1070-Anomaloscope.",
      "886.1435-Maxwell spot.",
      "886.1090-Haidinger brush.",
      "886.1350-Keratoscope.",
      "886.1450-Corneal radius measuring device.",
      "886.1040-Ocular esthesiometer.",
      "886.1160-Color vision plate illuminator.",
      "886.5540-Low-vision magnifier.",
      "886.5820-Closed-circuit television reading system.",
      "886.5120-Low-power binocular loupe.",
      "886.1395-Diagnostic Hruby fundus lens.",
      "886.1390-Flexible diagnostic Fresnel lens.",
      "886.1385-Polymethylmethacrylate (PMMA) diagnostic contact lens.",
      "886.1380-Diagnostic condensing lens.",
      "886.1945-Transilluminator.",
      "886.1850-AC-powered slitlamp biomicroscope.",
      "886.1870-Stereoscope.",
      "886.1910-Spectacle dissociation test system.",
      "886.1340-Haploscope.",
      "886.1050-Adaptometer (biophotometer).",
      "886.5810-Ophthalmic prism reader.",
      "886.5800-Ophthalmic bar reader.",
      "886.5600-Ptosis crutch.",
      "886.1905-Nystagmus tape.",
      "886.1770-Manual refractor.",
      "886.1760-Ophthalmic refractometer.",
      "886.4150-Vitreous aspiration and cutting instrument.",
      "886.1665-Ophthalmic rotary prism.",
      "886.1400-Maddox lens.",
      "886.1660-Gonioscopic prism.",
      "886.1655-Ophthalmic Fresnel prism.",
      "886.1650-Ophthalmic bar prism.",
      "886.1930-Tonometer and accessories.",
      "886.1940-Tonometer sterilizer.",
      "886.1460-Stereopsis measuring instrument.",
      "886.4070-Powered corneal burr.",
      "886.1790-Nearpoint ruler.",
      "886.1430-Ophthalmic contact lens radius measuring device.",
      "886.1700-Pupillometer.",
      "886.1570-Ophthalmoscope.",
      "886.1810-Tangent screen (campimeter).",
      "886.1510-Eye movement monitor.",
      "886.1425-Lens measuring instrument.",
      "886.1420-Ophthalmic lens gauge.",
      "886.1880-Fusion and stereoscopic target.",
      "886.1270-Exophthalmometer.",
      "886.1640-Ophthalmic preamplifier.",
      "886.1630-AC-powered photostimulator.",
      "886.1220-Corneal electrode.",
      "886.1140-Ophthalmic chair.",
      "886.1860-Ophthalmic instrument stand.",
      "886.1750-Skiascopic rack.",
      "886.1250-Euthyscope.",
      "886.1190-Distometer.",
      "886.4570-Ophthalmic surgical marker.",
      "886.4230-Ophthalmic knife test drum.",
      "886.4350-Manual ophthalmic surgical instrument.",
      "886.4370-Keratome.",
      "886.4770-Ophthalmic operating spectacles (loupes).",
      "886.5840-Magnifying spectacles.",
      "886.1605-Perimeter.",
      "886.1330-Amsler grid.",
      "886.1840-Simulatan (including crossed cylinder).",
      "886.1680-Ophthalmic projector.",
      "886.5910-Image intensification vision aid.",
      "886.1200-Optokinetic drum.",
      "886.1150-Visual acuity chart.",
      "886.4750-Ophthalmic eye shield.",
      "886.4790-Ophthalmic sponge.",
      "886.1415-Ophthalmic trial lens frame.",
      "886.1410-Ophthalmic trial lens clip.",
      "886.1405-Ophthalmic trial lens set.",
      "886.1375-Bagolini lens.",
      "886.5915-Optical vision aid.",
      "886.5900-Electronic vision aid.",
      "886.1360-Visual field laser instrument.",
      "886.1290-Fixation device.",
      "886.4400-Electronic metal locator.",
      "886.4440-AC-powered magnet.",
      "886.4170-Cryophthalmic unit.",
      "886.1670-Ophthalmic isotope uptake probe.",
      "886.4250-Ophthalmic electrolysis unit.",
      "886.3320-Eye sphere implant.",
      "886.4690-Ophthalmic photocoagulator.",
      "886.4670-Phacofragmentation system.",
      "886.5916-Rigid gas permeable contact lens.",
      "886.4390-Ophthalmic laser.",
      "886.5844-Prescription spectacle lens.",
      "886.3200-Artificial eye.",
      "886.3300-Absorbable implant (scleral buckling method).",
      "886.3600-Intraocular lens.",
      "886.3400-Keratoprosthesis.",
      "886.3130-Ophthalmic conformer.",
      "886.4115-Thermal cautery unit.",
      "886.4100-Radiofrequency electrosurgical cautery apparatus.",
      "886.3800-Scleral shell.",
      "886.3100-Ophthalmic tantalum clip.",
      "886.3340-Extraocular orbital implant.",
      "886.5850-Sunglasses (nonprescription).",
      "886.5842-Spectacle frame.",
      "886.5928-Soft (hydrophilic) contact lens care products.",
      "886.1690-Pupillograph.",
      "886.4855-Ophthalmic instrument table.",
      "886.5100-Ophthalmic beta radiation source.",
      "886.4300-Intraocular lens guide.",
      "886.1800-Schirmer strip.",
      "886.5420-Contact lens inserter/remover.",
      "886.3920-Aqueous shunt.",
      "886.4360-Ocular surgery irrigation device.",
      "886.4610-Ocular pressure applicator.",
      "886.5925-Soft (hydrophilic) contact lens.",
      "886.4270-Intraocular gas.",
      "886.4275-Intraocular fluid.",
      "886.4155-Scleral plug.",
      "886.4392-Nd:YAG laser for posterior capsulotomy and peripheral iridotomy.",
      "886.5350-Ultrasound cyclodestructive device.",
      "886.1300-Afterimage flasher.",
      "886.1342-Strabismus detection device.",
      "886.5300-Tear electrostimulation device.",
      "886.5305-Electromechanical tear stimulator.",
      "886.5310-Intranasal electrostimulation device for dry eye symptoms.",
      "886.4320",
      "886.4355-Corneal inlay inserter handle.",
      "886.5201-Intense pulsed light device for managing dry eye.",
      "886.5919-Hydrophilic re-coating solution.",
      "886.5000",
      "886.5500",
      "886.1600",
      "886.5520",
      "892.2010-Medical image storage device.",
      "892.2020-Medical image communications device.",
      "892.2030-Medical image digitizer.",
      "892.2040-Medical image hardcopy device.",
      "892.2050-Medical image management and processing system.",
      "878.4820-Surgical instrument motors and accessories/attachments.",
      "878.4400-Electrosurgical cutting and coagulation device and accessories.",
      "886.1100-Retinal diagnostic software device.",
      "886.5905-Oral electronic vision aid.",
      "886.5838-Nasolacrimal compression device.",
      "886.1925-Diurnal pattern recorder system.",
      "(blank)",
    ],
  },
  {
    label: "Gastroenterology and Urology",
    value: "GU",
    regCodes: [
      "876.1050-Endoscopic transhepatic venous access needle.",
      "876.1075-Gastroenterology-urology biopsy instrument.",
      "876.1080-Gastroenterology-urology accessories to a biopsy instrument.",
      "876.1300-Ingestible telemetric gastrointestinal capsule imaging system.",
      "876.1305",
      "876.1310-Magnetically maneuvered capsule endoscopy system.",
      "876.1330-Colon capsule endoscopy system.",
      "876.1390",
      "876.1400-Stomach pH electrode.",
      "876.1450-Esophageal tissue characterization system.",
      "876.1500-Endoscope and accessories.",
      "876.1510",
      "876.1520-Gastrointestinal lesion software detection system.",
      "876.1530",
      "876.1540",
      "876.1550",
      "876.1620-Urodynamics measurement system.",
      "876.1725-Gastrointestinal motility monitoring system.",
      "876.1735-Electrogastrography system.",
      "876.1800-Urine flow or volume measuring system.",
      "876.2040-Enuresis alarm.",
      "876.2050-Prostate lesion documentation system.",
      "876.2100-Pressure ulcer management tool.",
      "876.3350-Penile inflatable implant.",
      "876.3500-Penile implant surgical accessories.",
      "876.3630-Penile rigidity implant.",
      "876.3750-Testicular prosthesis.",
      "876.4020-Fiberoptic light ureteral catheter.",
      "876.4100",
      "876.4270-Colostomy rod.",
      "876.4300-Endoscopic electrosurgical unit and accessories.",
      "876.4310-Endoscopic electrosurgical clip cutting system.",
      "876.4330-Endoscopic pancreatic debridement device.",
      "876.4340-High intensity ultrasound system for prostate tissue ablation.",
      "876.4350-Fluid jet system for prostate tissue removal.",
      "876.4370-Gastroenterology-urology evacuator.",
      "876.4400-Hemorrhoidal ligator.",
      "876.4410",
      "876.4480-Electrohydraulic lithotriptor.",
      "876.4500-Mechanical lithotriptor.",
      "876.4530-Gastroenterology-urology fiberoptic retractor.",
      "876.4560-Ribdam.",
      "876.4590-Interlocking urethral sound.",
      "876.4620-Ureteral stent.",
      "876.4630-Ureteral stent accessories.",
      "876.4650-Water jet renal stone dislodger system.",
      "876.4680-Ureteral stone dislodger.",
      "876.4690",
      "876.4730-Manual gastroenterology-urology surgical instrument and accessories.",
      "876.4770-Urethrotome.",
      "876.4890-Urological table and accessories.",
      "876.5010-Biliary catheter and accessories.",
      "876.5011-Metallic biliary stent system for benign strictures.",
      "876.5012-Biliary stent, drain, and dilator accessories.",
      "876.5015-Pancreatic drainage stent and delivery system.",
      "876.5016",
      "876.5020-External penile rigidity devices.",
      "876.5021",
      "876.5025-Vibrator for climax control of premature ejaculation.",
      "876.5026-Non-implanted electrical stimulation device for management of premature ejaculation.",
      "876.5030-Continent ileostomy catheter.",
      "876.5090-Suprapubic urological catheter and accessories.",
      "876.5100-Suprapubic catheter accessories.",
      "876.5130-Urological catheter and accessories.",
      "876.5140-Urethral insert with pump for bladder drainage.",
      "876.5160-Urological clamp.",
      "876.5210-Enema kit.",
      "876.5220-Colonic irrigation system.",
      "876.5250-Urine collector and accessories.",
      "876.5270-Implanted electrical urinary continence device.",
      "876.5280-Implanted mechanical/hydraulic urinary continence device.",
      "876.5290-Implanted mechanical/hydraulic urinary continence device surgical accessories.",
      "876.5305",
      "876.5310-Nonimplanted, peripheral electrical continence device.",
      "876.5320-Nonimplanted electrical continence device.",
      "876.5330-Transcutaneous electrical continence device.",
      "876.5340-Nonimplanted nerve stimulator for functional abdominal pain relief.",
      "876.5360",
      "876.5365-Esophageal dilator.",
      "876.5450-Rectal dilator.",
      "876.5470-Ureteral dilator.",
      "876.5510",
      "876.5520-Urethral dilator.",
      "876.5530-Implantable transprostatic tissue retractor system.",
      "876.5540-Blood access device and accessories.",
      "876.5550-Prostatic artery embolization device.",
      "876.5600-Sorbent regenerated dialysate delivery system for hemodialysis.",
      "876.5630-Peritoneal dialysis system and accessories.",
      "876.5665-Water purification system for hemodialysis.",
      "876.5820-Hemodialysis system and accessories.",
      "876.5830-Hemodialyzer with disposable insert (Kiil type).",
      "876.5860-High permeability hemodialysis system.",
      "876.5861-Pediatric continuous renal replacement therapy system.",
      "876.5862-Hemodialyzer with expanded solute removal profile.",
      "876.5870-Sorbent hemoperfusion system.",
      "876.5880-Isolated kidney perfusion and transport system and accessories.",
      "876.5885-Tissue culture media for human ex vivo tissue and cell culture processing applications.",
      "876.5895-Ostomy irrigator.",
      "876.5900-Ostomy pouch and accessories.",
      "876.5920-Protective garment for incontinence.",
      "876.5930-Rectal control system.",
      "876.5940",
      "876.5955-Peritoneo-venous shunt.",
      "876.5960-Computerized behavioral therapy device for treating symptoms of gastrointestinal conditions.",
      "876.5970-Hernia support.",
      "876.5980-Gastrointestinal tube and accessories.",
      "876.5981-Oral removable palatal space occupying device for weight management and/or weight loss.",
      "876.5982-Ingested, transient, space occupying device for weight management and/or weight loss.",
      "876.5983",
      "876.5990-Extracorporeal shock wave lithotripter.",
      "870.2770-Impedance plethysmograph.",
      "878.3300-Surgical mesh.",
      "878.3610-Esophageal prosthesis.",
      "878.4350-Cryosurgical unit and accessories.",
      "878.4400-Electrosurgical cutting and coagulation device and accessories.",
      "878.4810-Laser surgical instrument for use in general and plastic surgery and in dermatology.",
      "880.6316",
      "882.5850-Implanted spinal cord stimulator for bladder evacuation.",
      "884.1425-Perineometer.",
      "884.1690-Hysteroscope and accessories.",
      "884.1720-Gynecologic laparoscope and accessories.",
      "884.4530-Obstetric-gynecologic specialized manual instrument.",
      "884.4910-Specialized surgical instrumentation for use with urogynecologic surgical mesh.",
      "890.5050-Daily activity assist device.",
      "(blank)",
    ],
  },
  {
    label: "Microbiology",
    value: "MI",
    regCodes: [
      "610.40",
      "862.1660-Quality control material (assayed and unassayed).",
      "862.2570-Instrumentation for clinical multiplex test systems.",
      "864.1850-Dye and chemical solution stains.",
      "866.1620-Antimicrobial susceptibility test disc.",
      "866.1640-Antimicrobial susceptibility test powder.",
      "866.1645-Fully automated short-term incubation cycle antimicrobial susceptibility system.",
      "866.1650",
      "866.1655-System for detection of microorganisms and antimicrobial resistance using reporter expression.",
      "866.1660",
      "866.1700-Culture medium for antimicrobial susceptibility tests.",
      "866.2050-Staphylococcal typing bacteriophage.",
      "866.2120-Anaerobic chamber.",
      "866.2160-Coagulase plasma.",
      "866.2170-Automated colony counter.",
      "866.2180-Manual colony counter.",
      "866.2190-Automated image assessment system for microbial colonies on solid culture media.",
      "866.2300-Multipurpose culture medium.",
      "866.2320-Differential culture medium.",
      "866.2330-Enriched culture medium.",
      "866.2350-Microbiological assay culture medium.",
      "866.2360-Selective culture medium.",
      "866.2390-Transport culture medium.",
      "866.2410-Culture medium for pathogenic Neisseria spp.",
      "866.2420-Oxidase screening test for gonorrhea.",
      "866.2440-Automated medium dispensing and stacking device.",
      "866.2450-Supplement for culture media.",
      "866.2480-Quality control kit for culture media.",
      "866.2500-Microtiter diluting and dispensing device.",
      "866.2540-Microbiological incubator.",
      "866.2560-Microbial growth monitor.",
      "866.2580-Gas-generating device.",
      "866.2600-Wood's fluorescent lamp.",
      "866.2660-Microorganism differentiation and identification device.",
      "866.2680-Streptococcus spp. nucleic acid-based assay.",
      "866.2900-Microbiological specimen collection and transport device.",
      "866.2950",
      "866.2952",
      "866.3010-Acinetobacter calcoaceticus serological reagents.",
      "866.3020-Adenovirus serological reagents.",
      "866.3035-Arizona spp. serological reagents.",
      "866.3040-Aspergillus spp. serological reagents.",
      "866.3045-In vitro diagnostic device for Bacillus spp. detection.",
      "866.3046",
      "866.3050-Beta-glucan serological assays.",
      "866.3060-Blastomyces dermatitidis serological reagents.",
      "866.3065-Bordetella spp. serological reagents.",
      "866.3085-Brucella spp. serological reagents.",
      "866.3110-Campylobacter fetus serological reagents.",
      "866.3120-Chlamydia serological reagents.",
      "866.3125-Citrobacter spp. serological reagents.",
      "866.3130-Clostridium difficile toxin gene amplification assay.",
      "866.3135-Coccidioides immitis serological reagents.",
      "866.3140-Corynebacterium spp. serological reagents.",
      "866.3145-Coxsackievirus serological reagents.",
      "866.3165-Cryptococcus neoformans serological reagents.",
      "866.3170-Nucleic acid-based hepatitis C virus ribonucleic acid tests.",
      "866.3171",
      "866.3175-Cytomegalovirus serological reagents.",
      "866.3180-Quantitative cytomegalovirus nucleic acid tests for transplant patient management.",
      "866.3181",
      "866.3183-Quantitative viral nucleic acid test for transplant patient management.",
      "866.3200-Echinococcus spp. serological reagents.",
      "866.3205-Echovirus serological reagents.",
      "866.3210-Endotoxin assay.",
      "866.3215-Device to detect and measure non-microbial analyte(s) in human clinical specimens to aid in assessment of patients with suspected sepsis.",
      "866.3220-Entamoeba histolytica serological reagents.",
      "866.3225-Enterovirus nucleic acid assay.",
      "866.3230",
      "866.3231",
      "866.3235-Epstein-Barr virus serological reagents.",
      "866.3236-Device to detect or measure nucleic acid from viruses associated with head and neck cancers.",
      "866.3250-Erysipelothrix rhusiopathiae serological reagents.",
      "866.3255-Escherichia coli serological reagents.",
      "866.3270-Flavobacterium spp. serological reagents.",
      "866.3280-Francisella tularensis serological reagents.",
      "866.3290-Gonococcal antibody test (GAT).",
      "866.3300-Haemophilus spp. serological reagents.",
      "866.3305-Herpes simplex virus serological assays.",
      "866.3307",
      "866.3309-Herpes virus nucleic acid-based cutaneous and mucocutaneous lesion panel.",
      "866.3310-Hepatitis A virus (HAV) serological assays.",
      "866.3315",
      "866.3316",
      "866.3320-Histoplasma capsulatum serological reagents.",
      "866.3328-Influenza virus antigen detection test system.",
      "866.3330-Influenza virus serological reagents.",
      "866.3332-Reagents for detection of specific novel influenza A viruses.",
      "866.3336-John Cunningham Virus serological reagents.",
      "866.3340-Klebsiella spp. serological reagents.",
      "866.3350-Leptospira spp. serological reagents.",
      "866.3355-Listeria spp. serological reagents.",
      "866.3360-Lymphocytic choriomeningitis virus serological reagents.",
      "866.3361-Mass spectrometer system for clinical use for the identification of microorganisms.",
      "866.3365-Multiplex nucleic acid assay for identification of microorganisms and resistance markers from positive blood cultures.",
      "866.3367",
      "866.3370-Mycobacterium tuberculosis immunofluorescent reagents.",
      "866.3372-Nucleic acid-based in vitro diagnostic devices for the detection of Mycobacterium tuberculosis complex in respiratory specimens.",
      "866.3373-Nucleic acid-based in vitro diagnostic devices for the detection of Mycobacterium tuberculosis complex (MTB-complex) and the genetic mutations associated with MTB-complex antibiotic resistance in respiratory specimens.",
      "866.3375-Mycoplasma spp. serological reagents.",
      "866.3376",
      "866.3378",
      "866.3380-Mumps virus serological reagents.",
      "866.3385",
      "866.3386",
      "866.3390-Neisseria spp. direct serological test reagents.",
      "866.3393",
      "866.3395-Norovirus serological reagents.",
      "866.3400-Parainfluenza virus serological reagents.",
      "866.3402-Plasmodium species antigen detection assays.",
      "866.3405-Poliovirus serological reagents.",
      "866.3410-Proteus spp. (Weil-Felix) serological reagents.",
      "866.3415-Pseudomonas spp. serological reagents.",
      "866.3460-Rabiesvirus immunofluorescent reagents.",
      "866.3470-Reovirus serological reagents.",
      "866.3480-Respiratory syncytial virus serological reagents.",
      "866.3490-Rhinovirus serological reagents.",
      "866.3500-Rickettsia serological reagents.",
      "866.3510-Rubella virus serological reagents.",
      "866.3520-Rubeola (measles) virus serological reagents.",
      "866.3550-Salmonella spp. serological reagents.",
      "866.3600-Schistosoma spp. serological reagents.",
      "866.3630-Serratia spp. serological reagents.",
      "866.3660-Shigella spp. serological reagents.",
      "866.3680-Sporothrix schenckii serological reagents.",
      "866.3700-Staphylococcus aureus serological reagents.",
      "866.3720-Streptococcus spp. exoenzyme reagents.",
      "866.3740-Streptococcus spp. serological reagents.",
      "866.3780-Toxoplasma gondii serological reagents.",
      "866.3820-Treponema pallidum nontreponemal test reagents.",
      "866.3830-Treponema pallidum treponemal test reagents.",
      "866.3850-Trichinella spiralis serological reagents.",
      "866.3860-Trichomonas vaginalis nucleic acid assay.",
      "866.3870-Trypanosoma spp. serological reagents.",
      "866.3900-Varicella-zoster virus serological reagents.",
      "866.3920-Assayed quality control material for clinical microbiology assays.",
      "866.3930-Vibrio cholerae serological reagents.",
      "866.3935",
      "866.3940-West Nile virus serological reagents.",
      "866.3945-Dengue virus serological reagents.",
      "866.3946-Dengue virus nucleic acid amplification test reagents.",
      "866.3955-Human immunodeficiency virus (HIV) drug resistance genotyping assay using next generation sequencing technology.",
      "866.3956-Human immunodeficiency virus (HIV) serological diagnostic and/or supplemental test.",
      "866.3957-Human immunodeficiency virus (HIV) nucleic acid (NAT) diagnostic and/or supplemental test.",
      "866.3960-Nucleic acid-based device for the amplification, detection, and identification of microbial pathogens directly from whole blood specimens.",
      "866.3966-Device to detect and identify selected microbial agents that cause acute febrile illness.",
      "866.3967",
      "866.3970-Device to detect and identify microbial pathogen nucleic acids in cerebrospinal fluid.",
      "866.3975",
      "866.3980-Respiratory viral panel multiplex nucleic acid assay.",
      "866.3981-Device to detect and identify nucleic acid targets in respiratory specimens from microbial agents that cause the SARS-CoV-2 respiratory infection and other microbial agents when in a multi-target test.",
      "866.3982",
      "866.3983",
      "866.3984",
      "866.3985-Device to detect and identify microorganisms and associated resistance marker nucleic acids directly in respiratory specimens.",
      "866.3986",
      "866.3987",
      "866.3988",
      "866.3990-Gastrointestinal microorganism multiplex nucleic acid-based assay.",
      "866.4000",
      "866.4001",
      "866.4002",
      "(blank)",
    ],
  },
  {
    label: "Hematology",
    value: "HE",
    regCodes: [
      "864.7875-Thrombin time test.",
      "864.7875-Thrombin time test.",
      "864.7490-Sulfhemoglobin assay.",
      "864.6160-Manual blood cell counting device.",
      "864.1850-Dye and chemical solution stains.",
      "864.1850-Dye and chemical solution stains.",
      "864.1850-Dye and chemical solution stains.",
      "864.8200-Blood cell diluent.",
      "864.8625-Hematology quality control mixture.",
      "868.1890-Predictive pulmonary-function value calculator.",
      "862.2050-General purpose laboratory equipment labeled or promoted for a specific medical use.",
      "864.9205-Blood and plasma warming device.",
      "864.9205-Blood and plasma warming device.",
      "864.7320-Fibrinogen/fibrin degradation products assay.",
      "864.7340-Fibrinogen determination system.",
      "864.7340-Fibrinogen determination system.",
      "864.7340-Fibrinogen determination system.",
      "864.7340-Fibrinogen determination system.",
      "864.7060-Antithrombin III assay.",
      "864.7340-Fibrinogen determination system.",
      "864.7925-Partial thromboplastin time tests.",
      "864.8625-Hematology quality control mixture.",
      "864.7525-Heparin assay.",
      "864.7340-Fibrinogen determination system.",
      "864.5425-Multipurpose system for in vitro coagulation studies.",
      "864.7500-Whole blood hemoglobin assays.",
      "864.6550-Occult blood test.",
      "864.8200-Blood cell diluent.",
      "864.8540-Red cell lysing reagent.",
      "864.8625-Hematology quality control mixture.",
      "864.8625-Hematology quality control mixture.",
      "864.5425-Multipurpose system for in vitro coagulation studies.",
      "864.7925-Partial thromboplastin time tests.",
      "864.7290-Factor deficiency test.",
      "864.7720-Prothrombin consumption test.",
      "864.7250-Erythropoietin assay.",
      "864.7925-Partial thromboplastin time tests.",
      "864.6160-Manual blood cell counting device.",
      "864.6160-Manual blood cell counting device.",
      "864.7500-Whole blood hemoglobin assays.",
      "864.7455-Fetal hemoglobin assay.",
      "864.6700-Erythrocyte sedimentation rate test.",
      "864.7660-Leukocyte alkaline phosphatase test.",
      "864.7320-Fibrinogen/fibrin degradation products assay.",
      "864.5350-Microsedimentation centrifuge.",
      "864.7825-Sickle cell test.",
      "864.6160-Manual blood cell counting device.",
      "864.7455-Fetal hemoglobin assay.",
      "864.5700-Automated platelet aggregation system.",
      "864.7425-Carboxyhemoglobin assay.",
      "864.6400-Hematocrit measuring device.",
      "864.5400-Coagulation instrument.",
      "864.8200-Blood cell diluent.",
      "864.7500-Whole blood hemoglobin assays.",
      "864.7375-Glutathione reductase assay.",
      "864.7340-Fibrinogen determination system.",
      "864.6150-Capillary blood collection tube.",
      "864.7415-Abnormal hemoglobin assay.",
      "864.8950-Russell viper venom reagent.",
      "864.7340-Fibrinogen determination system.",
      "864.7925-Partial thromboplastin time tests.",
      "864.5425-Multipurpose system for in vitro coagulation studies.",
      "864.8625-Hematology quality control mixture.",
      "864.7750-Prothrombin time test.",
      "864.7290-Factor deficiency test.",
      "864.6160-Manual blood cell counting device.",
      "864.7500-Whole blood hemoglobin assays.",
      "864.7415-Abnormal hemoglobin assay.",
      "864.5800-Automated sedimentation rate device.",
      "864.6600-Osmotic fragility test.",
      "864.5600-Automated hematocrit instrument.",
      "864.6400-Hematocrit measuring device.",
      "864.5240-Automated blood cell diluting apparatus.",
      "864.5850-Automated slide spinner.",
      "864.7500-Whole blood hemoglobin assays.",
      "864.5200-Automated cell counter.",
      "864.6160-Manual blood cell counting device.",
      "864.5400-Coagulation instrument.",
      "864.5400-Coagulation instrument.",
      "864.7900-Thromboplastin generation test.",
      "864.5620-Automated hemoglobin system.",
      "864.9245-Automated blood cell separator.",
      "864.6675-Platelet aggregometer.",
      "864.5200-Automated cell counter.",
      "864.5220-Automated differential cell counter.",
      "864.6160-Manual blood cell counting device.",
      "864.8625-Hematology quality control mixture.",
      "864.8625-Hematology quality control mixture.",
      "864.7500-Whole blood hemoglobin assays.",
      "864.7825-Sickle cell test.",
      "864.7440-Electrophoretic hemoglobin analysis system.",
      "864.7100-Red blood cell enzyme assay.",
      "864.7360-Erythrocytic glucose-6-phosphate dehydrogenase assay.",
      "864.7360-Erythrocytic glucose-6-phosphate dehydrogenase assay.",
      "864.7360-Erythrocytic glucose-6-phosphate dehydrogenase assay.",
      "864.7360-Erythrocytic glucose-6-phosphate dehydrogenase assay.",
      "864.7360-Erythrocytic glucose-6-phosphate dehydrogenase assay.",
      "864.7360-Erythrocytic glucose-6-phosphate dehydrogenase assay.",
      "864.7360-Erythrocytic glucose-6-phosphate dehydrogenase assay.",
      "864.7360-Erythrocytic glucose-6-phosphate dehydrogenase assay.",
      "864.7300-Fibrin monomer paracoagulation test.",
      "864.7275-Euglobulin lysis time tests.",
      "864.7140-Activated whole blood clotting time tests.",
      "864.7060-Antithrombin III assay.",
      "864.7525-Heparin assay.",
      "864.5400-Coagulation instrument.",
      "864.5300-Red cell indices device.",
      "864.6675-Platelet aggregometer.",
      "864.6675-Platelet aggregometer.",
      "864.6650-Platelet adhesion test.",
      "864.6100-Bleeding time device.",
      "864.8500-Lymphocyte separation medium.",
      "864.8200-Blood cell diluent.",
      "864.7660-Leukocyte alkaline phosphatase test.",
      "864.7415-Abnormal hemoglobin assay.",
      "864.8625-Hematology quality control mixture.",
      "864.8100-Bothrops atrox reagent.",
      "864.6550-Occult blood test.",
      "864.6550-Occult blood test.",
      "864.7360-Erythrocytic glucose-6-phosphate dehydrogenase assay.",
      "864.7360-Erythrocytic glucose-6-phosphate dehydrogenase assay.",
      "864.7360-Erythrocytic glucose-6-phosphate dehydrogenase assay.",
      "864.7375-Glutathione reductase assay.",
      "864.5680-Automated heparin analyzer.",
      "864.5260-Automated cell-locating device.",
      "864.5700-Automated platelet aggregation system.",
      "864.5425-Multipurpose system for in vitro coagulation studies.",
      "864.7415-Abnormal hemoglobin assay.",
      "864.7455-Fetal hemoglobin assay.",
      "864.7400-Hemoglobin A2 assay.",
      "864.7060-Antithrombin III assay.",
      "864.7735-Prothrombin-proconvertin test and thrombotest.",
      "864.6700-Erythrocyte sedimentation rate test.",
      "864.6400-Hematocrit measuring device.",
      "864.5300-Red cell indices device.",
      "864.8625-Hematology quality control mixture.",
      "864.5950-Blood volume measuring device.",
      "864.7040-Adenosine triphosphate release assay.",
      "864.7525-Heparin assay.",
      "864.6550-Occult blood test.",
      "864.7040-Adenosine triphosphate release assay.",
      "864.7500-Whole blood hemoglobin assays.",
      "864.7360-Erythrocytic glucose-6-phosphate dehydrogenase assay.",
      "864.7375-Glutathione reductase assay.",
      "864.5400-Coagulation instrument.",
      "864.5300-Red cell indices device.",
      "864.7455-Fetal hemoglobin assay.",
      "864.7340-Fibrinogen determination system.",
      "864.8150-Calibrator for cell indices.",
      "864.8175-Calibrator for platelet counting.",
      "864.8165-Calibrator for hemoglobin or hematocrit measurement.",
      "864.8185-Calibrator for red cell and white cell counting.",
      "864.9875-Transfer set.",
      "864.9750-Heat-sealing device.",
      "864.9700-Blood storage refrigerator and blood storage freezer.",
      "864.9650-Quality control kit for blood banking reagents.",
      "864.9600-Potentiating media for in vitro diagnostic use.",
      "864.9575-Environmental chamber for storage of platelet concentrate.",
      "864.9550-Lectins and protectins.",
      "864.9400-Stabilized enzyme solution.",
      "864.9320-Copper sulfate solution for specific gravity determinations.",
      "864.9300-Automated Coombs test systems.",
      "864.9285-Automated cell-washing centrifuge for immuno-hematology.",
      "864.9275-Blood bank centrifuge for in vitro diagnostic use.",
      "864.9225-Cell-freezing apparatus and reagents for in vitro diagnostic use.",
      "864.9195-Blood mixing devices and blood weighing devices.",
      "864.9100-Empty container for the collection and processing of blood and blood components.",
      "864.9050-Blood bank supplies.",
      "864.9125-Vacuum-assisted blood collection system.",
      "864.9145-Processing system for frozen blood.",
      "864.9160-Blood group substances of nonhuman origin for in vitro diagnostic use.",
      "864.9185-Blood grouping view box.",
      "864.9175-Automated blood grouping and antibody test system.",
      "864.9205-Blood and plasma warming device.",
      "864.7695-Platelet factor 4 radioimmunoassay.",
      "864.7470-Glycosylated hemoglobin assay.",
      "864.7500-Whole blood hemoglobin assays.",
      "864.7675-Leukocyte peroxidase test.",
      "864.5425-Multipurpose system for in vitro coagulation studies.",
      "864.7455-Fetal hemoglobin assay.",
      "864.7675-Leukocyte peroxidase test.",
      "864.5200-Automated cell counter.",
      "864.7100-Red blood cell enzyme assay.",
      "864.5425-Multipurpose system for in vitro coagulation studies.",
      "864.5220-Automated differential cell counter.",
      "864.7320-Fibrinogen/fibrin degradation products assay.",
      "864.7415-Abnormal hemoglobin assay.",
      "864.9165-Blood establishment computer software and accessories.",
      "864.9195-Blood mixing devices and blood weighing devices.",
      "864.9125-Vacuum-assisted blood collection system.",
      "864.8625-Hematology quality control mixture.",
      "864.7470-Glycosylated hemoglobin assay.",
      "864.8625-Hematology quality control mixture.",
      "864.8625-Hematology quality control mixture.",
      "864.2240-Cell and tissue culture supplies and equipment.",
      "864.9900-Cord blood processing system and storage container.",
      "864.5700-Automated platelet aggregation system.",
      "864.7750-Prothrombin time test.",
      "864.7280-Factor V Leiden DNA mutation detection systems.",
      "864.9900-Cord blood processing system and storage container.",
      "864.6550-Occult blood test.",
      "864.9175-Automated blood grouping and antibody test system.",
      "864.9245-Automated blood cell separator.",
      "864.6550-Occult blood test.",
      "864.5220-Automated differential cell counter.",
      "864.9175-Automated blood grouping and antibody test system.",
      "864.9245-Automated blood cell separator.",
      "864.5220-Automated differential cell counter.",
      "864.9245-Automated blood cell separator.",
      "864.5220-Automated differential cell counter.",
      "864.7010-Flow cytometric test system for hematopoietic neoplasms.",
      "864.5430",
      "864.7500-Whole blood hemoglobin assays.",
      "660.20",
      "660.50",
      "660.30",
      "864.7295-Heparin and direct oral factor Xa inhibitor drug test system.",
      "864.7293",
      "864.9115-Container system for the processing and storage of Red Blood Cell components under reduced oxygen conditions.",
      "864.7297",
      "864.5261",
      "880.5860-Piston syringe.",
      "866.5330-Factor XIII, A, S, immunological test system.",
      "866.5200-Carbonic anhydrase B and C immunological test system.",
      "866.5735-Prothrombin immunological test system.",
      "866.5200-Carbonic anhydrase B and C immunological test system.",
      "866.5715-Plasminogen immunological test system.",
      "866.5800-Seminal fluid (sperm) immunological test system.",
      "866.5700-Whole human plasma or serum immunological test system.",
      "866.5700-Whole human plasma or serum immunological test system.",
      "866.5200-Carbonic anhydrase B and C immunological test system.",
      "866.6010-Tumor-associated antigen immunological test system.",
      "866.5660-Multiple autoantibodies immunological test system.",
      "864.4400-Enzyme preparations.",
      "864.4010-General purpose reagent.",
      "864.4010-General purpose reagent.",
      "864.4010-General purpose reagent.",
      "864.4010-General purpose reagent.",
      "864.4020-Analyte specific reagents.",
      "(blank)",
    ],
  },
  {
    label: "Neurology",
    value: "NE",
    regCodes: [
      "882.4900-Skullplate screwdriver.",
      "882.4030-Skull plate anvil.",
      "882.5330-Preformed nonalterable cranioplasty plate.",
      "882.5900-Preformed craniosynostosis strip.",
      "882.5300-Methyl methacrylate for cranioplasty.",
      "882.5910-Dura substitute.",
      "882.5250-Burr hole cover.",
      "882.1610-Alpha monitor.",
      "882.5500-Lesion temperature monitor.",
      "882.1240-Echoencephalograph.",
      "882.1925-Ultrasonic scanner calibration test block.",
      "882.1320-Cutaneous electrode.",
      "882.1350-Needle electrode.",
      "882.1410-Electroencephalograph electrode/lead tester.",
      "882.1275-Electroconductive media.",
      "882.1310-Cortical electrode.",
      "882.1950-Tremor transducer.",
      "882.1855-Electroencephalogram (EEG) telemetry system.",
      "882.4545-Shunt system implantation instrument.",
      "882.5840-Implanted intracerebral/subcortical stimulator for pain relief.",
      "870.1330-Catheter guide wire.",
      "870.5900-Thermal regulating system.",
      "870.1290-Steerable catheter control system.",
      "870.1250-Percutaneous catheter.",
      "870.1200-Diagnostic intravascular catheter.",
      "870.2770-Impedance plethysmograph.",
      "870.1875-Stethoscope.",
      "870.2700-Oximeter.",
      "874.1820-Surgical nerve stimulator/locator.",
      "882.1890-Evoked response photic stimulator.",
      "882.1870-Evoked response electrical stimulator.",
      "882.1480-Neurological endoscope.",
      "882.1200-Two-point discriminator.",
      "882.1900-Evoked response auditory stimulator.",
      "882.1845-Physiological signal conditioner.",
      "882.1835-Physiological signal amplifier.",
      "882.1620-Intracranial pressure monitoring device.",
      "882.1460-Nystagmograph.",
      "882.5320-Preformed alterable cranioplasty plate.",
      "882.1400-Electroencephalograph.",
      "882.1430-Electroencephalograph test signal generator.",
      "882.1420-Electroencephalogram (EEG) signal spectrum analyzer.",
      "882.1030-Ataxiagraph.",
      "882.1525-Tuning fork.",
      "882.1750-Pinwheel.",
      "882.1700-Percussor.",
      "882.1500-Esthesiometer.",
      "882.5940-Electroconvulsive therapy device.",
      "882.4400-Radiofrequency lesion generator.",
      "882.4600-Leukotome.",
      "882.4250-Cryogenic surgical device.",
      "882.4725-Radiofrequency lesion probe.",
      "882.4750-Skull punch.",
      "882.5820-Implanted cerebellar stimulator.",
      "882.5880-Implanted spinal cord stimulator for pain relief.",
      "882.5870-Implanted peripheral nerve stimulator for pain relief.",
      "882.5810-External functional neuromuscular stimulator.",
      "882.5890-Transcutaneous electrical nerve stimulator for pain relief.",
      "882.1340-Nasopharyngeal electrode.",
      "882.1330-Depth electrode.",
      "882.1020-Rigidity analyzer.",
      "882.1825-Rheoencephalograph.",
      "882.1540-Galvanic skin response measurement device.",
      "882.1880-Evoked response mechanical stimulator.",
      "882.4275-Dowel cutting instrument.",
      "882.4800-Self-retaining retractor for neurosurgery.",
      "882.4525-Microsurgical instrument.",
      "882.4845-Powered rongeur.",
      "882.4840-Manual rongeur.",
      "882.4535-Nonpowered neurosurgical instrument.",
      "882.4650-Neurosurgical suture needle.",
      "882.4560-Stereotaxic instrument.",
      "882.5960-Skull tongs for traction.",
      "882.4700-Neurosurgical paddie.",
      "882.4370-Pneumatic cranial drill motor.",
      "882.4360-Electric cranial drill motor.",
      "882.4325-Cranial drill handpiece (brace).",
      "882.4310-Powered simple cranial drills, burrs, trephines, and their accessories.",
      "882.4305-Powered compound cranial drills, burrs, trephines, and their accessories.",
      "882.4300-Manual cranial drills, burrs, trephines, and their accessories",
      "882.4460-Neurosurgical head holder (skull clamp).",
      "882.4440-Neurosurgical headrests.",
      "882.4125-Neurosurgical chair.",
      "882.4150-Scalp clip.",
      "882.5225-Implanted malleable clip.",
      "882.4200-Clip removal instrument.",
      "882.4215-Clip rack.",
      "882.4190-Clip forming/cutting instrument.",
      "882.5360-Cranioplasty plate fastener.",
      "882.4500-Cranioplasty material forming instrument.",
      "882.5150-Intravascular occluding catheter.",
      "882.4100-Ventricular catheter.",
      "882.5235-Aversive conditioning device.",
      "882.5050-Biofeedback device.",
      "882.4060-Ventricular cannula.",
      "882.5175-Carotid artery clamp.",
      "882.5950-Neurovascular embolization device.",
      "882.5200-Aneurysm clip.",
      "882.4175-Aneurysm clip applier.",
      "882.1560-Skin potential measurement device.",
      "882.1570-Powered direct-contact temperature measurement device.",
      "882.1550-Nerve conduction velocity measurement device.",
      "882.1790-Ocular plethysmograph.",
      "882.5550-Central nervous system fluid shunt and components.",
      "882.5030-Methyl methacrylate for aneurysmorrhaphy.",
      "882.5275-Nerve cuff.",
      "882.5800-Cranial electrotherapy stimulator.",
      "882.5070-Bite block.",
      "882.1565",
      "882.5975",
      "882.5970-Cranial orthosis.",
      "882.1440-Neuropsychiatric interpretive electroencephalograph assessment aid.",
      "882.1450-Brain injury adjunctive interpretive electroencephalograph assessment aid.",
      "882.5892-External vagal nerve stimulator for headache.",
      "882.5894-Limited output transcutaneous piezoelectric stimulator for skin reactions associated with insect bites.",
      "882.5560-Cerebrospinal fluid shunt system.",
      "882.5891-Transcutaneous electrical nerve stimulator to treat headache.",
      "882.1470-Computerized cognitive assessment aid.",
      "882.5700-Thermal system for insomnia.",
      "882.1561-Evoked photon image capture device.",
      "882.5600-Neurovascular mechanical thrombectomy device for acute ischemic stroke treatment.",
      "882.1471-Computerized cognitive assessment aid for concussion.",
      "882.1630-Cranial motion measurement device.",
      "882.1580-Non-electroencephalogram (EEG) physiological signal based seizure monitoring system.",
      "882.5888",
      "882.5955-Temporary coil embolization assist device.",
      "882.5802-Transcranial magnetic stimulation system for neurological and psychiatric disorders and conditions.",
      "882.5801-Computerized behavioral therapy device for psychiatric disorders.",
      "882.5896-Percutaneous nerve stimulator for substance use disorders.",
      "882.5893-Thermal vestibular stimulator for headache.",
      "882.5897-External upper limb tremor stimulator.",
      "882.5889",
      "882.1455-Traumatic brain injury eye movement assessment aid.",
      "882.5805-Repetitive transcranial magnetic stimulation system.",
      "882.4950-Diagnostic neurosurgical microscope filter.",
      "882.5898-Transcutaneous electrical nerve stimulator for attention deficit hyperactivity disorder.",
      "882.5899-Trunk and limb electrical stimulator to treat headache.",
      "882.5705-Digital therapy device to reduce sleep disturbance for psychiatric conditions.",
      "882.1491-Pediatric Autism Spectrum Disorder diagnosis aid.",
      "882.5855-Brain stimulation programming planning software.",
      "890.5500-Infrared lamp.",
      "882.5887",
      "882.1454",
      "882.5260",
      "882.4110",
      "882.1871",
      "882.5803-Digital therapy device for Attention Deficit Hyperactivity Disorder.",
      "882.1935-Near Infrared (NIR) Brain Hematoma Detector.",
      "888.1250-Nonpowered dynamometer.",
      "888.5850-Nonpowered orthopedic traction apparatus and accessories.",
      "888.1520-Nonpowered goniometer.",
      "888.1500-Goniometer.",
      "888.1240-AC-powered dynamometer.",
      "890.1375-Diagnostic electromyograph.",
      "890.1385-Diagnostic electromyograph needle electrode.",
      "890.1615-Miniature pressure transducer.",
      "890.5760-Nonpowered lower extremity pressure wrap.",
      "882.5895-Vibratory counter-stimulation device.",
      "890.3480-Powered lower extremity exoskeleton.",
      "878.4810-Laser surgical instrument for use in general and plastic surgery and in dermatology.",
      "878.4800-Manual surgical instrument for general use.",
      "(blank)",
    ],
  },
  {
    label: "Chemistry",
    value: "CH",
    regCodes: [
      "862.1545-Parathyroid hormone test system.",
      "862.1445-Lactate dehydrogenase isoenzymes test system.",
      "862.1495-Magnesium test system.",
      "862.1100-Aspartate amino transferase (AST/SGOT) test system.",
      "862.1600-Potassium test system.",
      "862.1635-Total protein test system.",
      "862.1575-Phospholipid test system.",
      "862.1550-Urinary pH (nonquantitative) test system.",
      "862.1580-Phosphorus (inorganic) test system.",
      "862.1485-Luteinizing hormone test system.",
      "862.1440-Lactate dehydrogenase test system.",
      "862.1560-Urinary phenylketones (nonquantitative) test system.",
      "862.1465-Lipase test system.",
      "868.1890-Predictive pulmonary-function value calculator.",
      "862.1430-17-Ketosteroids test system.",
      "862.1385-17-Hydroxycorticosteroids (17-ketogenic steroids) test system.",
      "862.1390-5-Hydroxyindole acetic acid/serotonin test system.",
      "862.1460-Leucine aminopeptidase test system.",
      "862.1810-Vitamin B12 test system.",
      "862.1795-Vanilmandelic acid test system.",
      "862.1775-Uric acid test system.",
      "862.1770-Urea nitrogen test system.",
      "862.1785-Urinary urobilinogen (nonquantitative) test system.",
      "862.1710-Total triiodothyronine test system.",
      "862.1730-Free tyrosine test system.",
      "862.1705-Triglyceride test system.",
      "862.1700-Total thyroxine test system.",
      "862.1680-Testosterone test system.",
      "862.1695-Free thyroxine test system.",
      "862.1520-5\u2032-Nucleotidase test system.",
      "862.1685-Thyroxine-binding globulin test system.",
      "862.1630-Protein (fractionation) test system.",
      "862.1665-Sodium test system.",
      "862.1470-Lipid (total) test system.",
      "862.1370-Human growth hormone test system.",
      "862.1410-Iron (non-heme) test system.",
      "862.1405-Immunoreactive insulin test system.",
      "862.1345-Glucose test system.",
      "862.1625-Prolactin (lactogen) test system.",
      "862.1325-Gastrin test system.",
      "862.1280-Estrone test system.",
      "862.1330-Globulin test system.",
      "862.1265-Estriol test system.",
      "862.1300-Follicle-stimulating hormone test system.",
      "862.1225-Creatinine test system.",
      "862.1295-Folic acid test system.",
      "862.1175-Cholesterol (total) test system.",
      "862.1205-Cortisol (hydrocortisone and hydroxycorticosterone) test system.",
      "862.1215-Creatine phosphokinase/creatine kinase or isoenzymes test system.",
      "862.1230-Cyclic AMP test system.",
      "862.1170-Chloride test system.",
      "862.1200-Corticosterone test system.",
      "862.1145-Calcium test system.",
      "862.1195-Corticoids test system.",
      "862.1120-Blood gases (PCO2, PO2) and blood pH test system.",
      "862.1270-Estrogens (total, in pregnancy) test system.",
      "862.1260-Estradiol test system.",
      "862.1165-Catecholamines (total) test system.",
      "862.1160-Bicarbonate/carbon dioxide test system.",
      "862.1085-Angiotensin I and renin test system.",
      "862.1110-Bilirubin (total or direct) test system.",
      "862.1070-Amylase test system.",
      "862.1050-Alkaline phosphatase or isoenzymes test system.",
      "862.1035-Albumin test system.",
      "862.1080-Androsterone test system.",
      "862.1075-Androstenedione test system.",
      "862.1045-Aldosterone test system.",
      "862.1040-Aldolase test system.",
      "862.1030-Alanine amino transferase (ALT/SGPT) test system.",
      "862.1020-Acid phosphatase (total or prostatic) test system.",
      "862.1025-Adrenocorticotropic hormone (ACTH) test system.",
      "862.1155-Human chorionic gonadotropin (HCG) test system.",
      "862.1675-Blood specimen collection device.",
      "862.2050-General purpose laboratory equipment labeled or promoted for a specific medical use.",
      "862.1115-Urinary bilirubin and its conjugates (nonquantitative) test system.",
      "862.2150-Continuous flow sequential multiple chemistry analyzer for clinical use.",
      "862.2160-Discrete photometric chemistry analyzer for clinical use.",
      "862.2170-Micro chemistry analyzer for clinical use.",
      "862.2140-Centrifugal chemistry analyzer for clinical use.",
      "862.2310-Clinical sample concentrator.",
      "862.2500-Enzyme analyzer for clinical use.",
      "862.2320-Beta or gamma counter for clinical use.",
      "862.2720-Plasma oncometer for clinical use.",
      "862.2920-Plasma viscometer for clinical use.",
      "862.2730-Osmometer for clinical use.",
      "862.2485-Electrophoresis apparatus for clinical use.",
      "862.2540-Flame emission photometer for clinical use.",
      "862.2300-Colorimeter, photometer, or spectrophotometer for clinical use.",
      "862.1660-Quality control material (assayed and unassayed).",
      "862.1185-Compound S (11-deoxycortisol) test system.",
      "862.1245-Dehydroepiandrosterone (free and sulfate) test system.",
      "862.1135-C-peptides of proinsulin test system.",
      "862.1380-Hydroxybutyric dehydrogenase test system.",
      "862.1420-Isocitric dehydrogenase test system.",
      "862.1595-Porphyrins test system.",
      "862.1060-Delta-aminolevulinic acid test system.",
      "862.1130-Blood volume test system.",
      "862.1140-Calcitonin test system.",
      "862.1180-Chymotrypsin test system.",
      "862.1190-Copper test system.",
      "862.1210-Creatine test system.",
      "862.1240-Cystine test system.",
      "862.1250-Desoxycorticosterone test system.",
      "862.1285-Etiocholanolone test system.",
      "862.1290-Fatty acids test system.",
      "862.1305-Formiminoglutamic acid (FIGLU) test system.",
      "862.1315-Galactose-1-phosphate uridyl transferase test system.",
      "862.1320-Gastric acidity test system.",
      "862.1365-Glutathione test system.",
      "862.1605-Pregnanediol test system.",
      "862.1610-Pregnanetriol test system.",
      "862.1620-Progesterone test system.",
      "862.1655-Pyruvic acid test system.",
      "862.1690-Thyroid stimulating hormone test system.",
      "862.1395-17-Hydroxyprogesterone test system.",
      "862.1255-2,3-Diphosphoglyceric acid test system.",
      "862.1095-Ascorbic acid test system.",
      "862.1275-Estrogens (total, nonpregnancy) test system.",
      "862.1335-Glucagon test system.",
      "862.1585-Human placental lactogen test system.",
      "862.1375-Histidine test system.",
      "862.1400-Hydroxyproline test system.",
      "862.1415-Iron-binding capacity test system.",
      "862.1490-Lysozyme (muramidase) test system.",
      "862.1500-Malic dehydrogenase test system.",
      "862.1510-Nitrite (nonquantitative) test system.",
      "862.1515-Nitrogen (amino-nitrogen) test system.",
      "862.1535-Ornithine carbamyl transferase test system.",
      "862.1540-Osmolality test system.",
      "862.1555-Phenylalanine test system.",
      "862.1565-6-Phosphogluconate dehydrogenase test system.",
      "862.1570-Phosphohexose isomerase test system.",
      "862.1590-Porphobilinogen test system.",
      "862.1615-Pregnenolone test system.",
      "862.1650-Pyruvate kinase test system.",
      "862.1670-Sorbitol dehydrogenase test system.",
      "862.1725-Trypsin test system.",
      "862.1780-Urinary calculi (stones) test system.",
      "862.1530-Plasma oncometry test system.",
      "862.1720-Triose phosphate isomerase test system.",
      "862.1790-Uroporphyrin test system.",
      "862.1805-Vitamin A test system.",
      "862.1815-Vitamin E test system.",
      "862.1820-Xylose test system.",
      "862.1360-Gamma-glutamyl transpeptidase and isoenzymes test system.",
      "862.2100-Calculator/data processing module for clinical use.",
      "862.2400-Densitometer/scanner (integrating, reflectance, TLC, or radiochromatogram) for clinical use.",
      "862.2750-Pipetting and diluting system for clinical use.",
      "862.2700-Nephelometer for clinical use.",
      "862.2680-Microtitrator for clinical use.",
      "862.2800-Refractometer for clinical use.",
      "862.2560-Fluorometer for clinical use.",
      "862.1450-Lactic acid test system.",
      "862.1715-Triiodothyronine uptake test system.",
      "862.1090-Angiotensin converting enzyme (A.C.E.) test system.",
      "862.2900-Automated urinalysis system.",
      "862.1177-Cholylglycine test system.",
      "862.1187-Conjugated sulfolithocholic acid (SLCG) test system.",
      "862.1505-Mucopolysaccharides (nonquantitative) test system.",
      "862.1113-Bilirubin (total and unbound) in the neonate test system.",
      "862.1825-Vitamin D test system.",
      "862.1118-Biotinidase test system.",
      "862.1117-B-type natriuretic peptide test system.",
      "862.1055-Newborn screening test system for amino acids, free carnitine, and acylcarnitines using tandem mass spectrometry.",
      "862.2570-Instrumentation for clinical multiplex test systems.",
      "862.2120-Continuous glucose monitor data management system.",
      "862.1220-Acute kidney injury test system.",
      "862.1350-Continuous glucose monitor secondary alarm system.",
      "862.1488",
      "862.1840-Total 25-hydroxyvitamin D mass spectrometry test system.",
      "862.1373-Hemoglobin A1c test system.",
      "862.1355-Integrated continuous glucose monitoring system.",
      "862.1358-Insulin therapy adjustment device.",
      "862.1093",
      "862.1493",
      "880.5730-Alternate controller enabled infusion pump.",
      "862.1506",
      "862.1356-Interoperable automated glycemic controller.",
      "862.1676-Blood collection device for cell-free nucleic acids.",
      "862.1622-Prognostic test for assessment of liver related disease progression.",
      "862.1164",
      "862.1223",
      "862.1357",
      "862.1163-Cardiac allograft gene expression profiling test system.",
      "864.1860-Immunohistochemistry reagents and kits.",
      "880.5725-Infusion pump.",
      "880.5735",
      "866.5340-Ferritin immunological test system.",
      "862.3364",
      "866.2660-Microorganism differentiation and identification device.",
      "866.2900-Microbiological specimen collection and transport device.",
      "866.3958-Human immunodeficiency virus (HIV) viral load monitoring test.",
      "864.3260-OTC test sample collection systems for drugs of abuse testing.",
      "864.3010-Tissue processing equipment.",
      "864.3250-Specimen transport and storage container.",
      "862.3080-Breath nitric oxide test system.",
      "862.3040-Alcohol test system.",
      "(blank)",
    ],
  },
  {
    label: "Anesthesiology",
    value: "AN",
    regCodes: [
      "868.5820-Dental protector.",
      "868.6700-Anesthesia stool.",
      "868.6100-Anesthetic cabinet, table, or tray.",
      "868.1640-Helium gas analyzer.",
      "868.5310-Carbon dioxide absorber.",
      "868.1040-Powered algesimeter.",
      "868.5550-Anesthetic gas mask.",
      "868.5750-Inflatable tracheal tube cuff.",
      "868.5130-Anesthesia conduction filter.",
      "868.5120-Anesthesia conduction catheter.",
      "868.5150-Anesthesia conduction needle.",
      "868.5790-Tracheal tube stylet.",
      "868.6810-Tracheobronchial suction catheter.",
      "868.5160-Gas machine for anesthesia or analgesia.",
      "868.5420-Ether hook.",
      "868.5320-Reservoir bag.",
      "868.6250-Portable air compressor.",
      "868.5560-Gas mask head strap.",
      "868.5925-Powered emergency ventilator.",
      "868.5915-Manual emergency ventilator.",
      "868.5800-Tracheostomy tube and tube cuff.",
      "868.5100-Nasopharyngeal airway.",
      "868.5730-Tracheal tube.",
      "868.5720-Bronchial tube.",
      "868.5450-Respiratory gas humidifier.",
      "868.1890-Predictive pulmonary-function value calculator.",
      "868.5780-Tube introduction forceps.",
      "868.5090-Emergency airway needle.",
      "868.5690-Incentive spirometer.",
      "868.5400-Electroanesthesia apparatus.",
      "868.1975-Water vapor analyzer.",
      "868.2610-Gas pressure gauge.",
      "868.6225-Nose clip.",
      "868.6400-Calibration gas.",
      "868.1030-Manual algesimeter.",
      "868.2775-Electrical peripheral nerve stimulator.",
      "868.2900-Gas pressure transducer.",
      "868.2885-Gas flow transducer.",
      "868.1800-Rhinoanemometer.",
      "868.1780-Inspiratory airway pressure meter.",
      "868.1870-Gas volume calibrator.",
      "868.2620-Gas pressure calibrator.",
      "868.2350-Gas calibration flowmeter.",
      "868.5375-Heat and moisture condenser (artificial nose).",
      "868.5965-Positive end expiratory pressure breathing attachment.",
      "868.5600-Venturi mask.",
      "868.5580-Oxygen mask.",
      "868.5995-Tee drain (water trap).",
      "868.5665-Powered percussor.",
      "868.5655-Portable liquid oxygen unit.",
      "868.5710-Electrically powered oxygen tent.",
      "868.5700-Nonpowered oxygen tent.",
      "868.2320-Uncompensated thorpe tube flowmeter.",
      "868.5365-Posture chair for cardiac or pulmonary treatment.",
      "868.5220-Blow bottle.",
      "868.5620-Breathing mouthpiece.",
      "868.2875-Differential pressure transducer.",
      "868.5935-External negative pressure ventilator.",
      "868.5675-Rebreathing device.",
      "868.5860-Pressure tubing and accessories.",
      "868.5810-Airway connector.",
      "868.5350-Nasal oxygen catheter.",
      "868.1880-Pulmonary-function data calculator.",
      "868.5905-Noncontinuous ventilator (IPPB).",
      "868.5270-Breathing system heater.",
      "868.1840-Diagnostic spirometer.",
      "868.1860-Peak-flow meter for spirometry.",
      "868.1850-Monitoring spirometer.",
      "868.1730-Oxygen uptake computer.",
      "868.1900-Diagnostic pulmonary-function interpretation calculator.",
      "868.6175-Cardiopulmonary emergency cart.",
      "868.5975-Ventilator tubing.",
      "868.2375-Breathing frequency monitor.",
      "868.5330-Breathing gas mixer.",
      "868.1930-Stethoscope head.",
      "868.1920-Esophageal stethoscope with electrical conductors.",
      "868.1910-Esophageal stethoscope.",
      "868.5880-Anesthetic vaporizer.",
      "868.5110-Oropharyngeal airway.",
      "868.5630-Nebulizer.",
      "868.5250-Breathing circuit circulator.",
      "868.5240-Anesthesia breathing circuit.",
      "868.5530-Flexible laryngoscope.",
      "868.6885-Medical gas yoke assembly.",
      "868.2700-Pressure regulator.",
      "868.5650-Esophageal obturator.",
      "868.2600-Airway pressure monitor.",
      "868.5340-Nasal oxygen cannula.",
      "868.5440-Portable oxygen generator.",
      "868.2340-Compensated thorpe tube flowmeter.",
      "868.5140-Anesthesia conduction kit.",
      "868.2025-Ultrasonic air embolism monitor.",
      "868.5470-Hyperbaric chamber.",
      "868.5760-Cuff spreader.",
      "868.5770-Tracheal tube fixation device.",
      "868.5740-Tracheal/bronchial differential ventilation tube.",
      "868.5895-Continuous ventilator.",
      "868.5300-Carbon dioxide absorbent.",
      "868.5430-Gas-scavenging apparatus.",
      "868.5955-Intermittent mandatory ventilation attachment.",
      "868.5870-Nonrebreathing valve.",
      "868.1500-Enflurane gas analyzer.",
      "868.1700-Nitrous oxide gas analyzer.",
      "868.1620-Halothane gas analyzer.",
      "868.5165-Nitric oxide administration apparatus.",
      "868.2380-Nitric oxide analyzer.",
      "868.2385-Nitrogen dioxide analyzer.",
      "868.5115-Device to relieve acute upper airway obstruction.",
      "868.1100-Arterial blood sampling kit.",
      "868.1170-Indwelling blood hydrogen ion concentration (pH) analyzer.",
      "868.1150-Indwelling blood carbon dioxide partial pressure (P2CO2) analyzer.",
      "868.1200-Indwelling blood oxygen partial pressure (PO2) analyzer.",
      "868.1690-Nitrogen gas analyzer.",
      "868.1430-Carbon monoxide gas analyzer.",
      "868.1400-Carbon dioxide gas analyzer.",
      "868.1720-Oxygen gas analyzer.",
      "868.1750-Pressure plethysmograph.",
      "868.2300-Bourdon gauge flowmeter.",
      "868.5180-Rocking bed.",
      "868.5640-Medicinal nonventilatory nebulizer (atomizer).",
      "868.5170-Laryngotracheal topical anesthesia applicator.",
      "868.5540-Rigid laryngoscope.",
      "868.6820-Patient position support.",
      "868.5795-Tracheal tube cleaning brush.",
      "868.2377-Apnea monitor.",
      "868.2550-Pneumotachometer.",
      "868.5280-Breathing tube support.",
      "868.1120-Indwelling blood oxyhemoglobin concentration analyzer.",
      "868.1670-Neon gas analyzer.",
      "868.1075-Argon gas analyzer.",
      "868.1760-Volume plethysmograph.",
      "868.2450-Lung water monitor.",
      "868.1965-Switching valve (ploss).",
      "868.5460-Therapeutic humidifier for home use.",
      "868.5570-Nonrebreathing mask.",
      "868.1575-Gas collection vessel.",
      "868.5590-Scavenging mask.",
      "868.2480-Cutaneous carbon dioxide (PcCO2) monitor.",
      "868.2250",
      "868.5105-External negative pressure airway aid.",
      "870.2720",
      "868.5454-High flow humidified oxygen delivery device.",
      "868.5273-Positive airway pressure delivery system.",
      "868.5095-Retrograde intubation device.",
      "868.1505-Ventilatory electrical impedance tomograph.",
      "868.1980",
      "868.2200",
      "868.1985",
      "868.2378",
      "868.3721",
      "870.2710-Ear oximeter.",
      "870.2700-Oximeter.",
      "870.5050-Patient care suction apparatus.",
      "870.1875-Stethoscope.",
      "872.5570-Intraoral devices for snoring and intraoral devices for snoring and obstructive sleep apnea.",
      "874.4500-Ear, nose, and throat microsurgical carbon dioxide laser.",
      "868.2376",
      "876.4680-Ureteral stone dislodger.",
      "876.4300-Endoscopic electrosurgical unit and accessories.",
      "868.5480-Isocapnic ventilation device.",
      "882.5830-Implanted diaphragmatic/phrenic nerve stimulator.",
      "890.5050-Daily activity assist device.",
      "878.3720-Tracheal prosthesis.",
      "878.4755-Absorbable lung biopsy plug.",
      "(blank)",
    ],
  },
  {
    label: "Cardiovascular",
    value: "CV",
    regCodes: [
      "870.3630-Pacemaker generator function analyzer.",
      "870.3620-Pacemaker lead adaptor.",
      "870.3600-External pacemaker pulse generator.",
      "870.3730-Pacemaker service tools.",
      "870.2800-Medical magnetic tape recorder.",
      "870.1025-Arrhythmia detector and alarm (including ST-segment measurement and alarm).",
      "870.1100-Blood pressure alarm.",
      "870.1110-Blood pressure computer.",
      "870.2640-Portable leakage current alarm.",
      "870.3535-Intra-aortic balloon and control system.",
      "870.3850-Carotid sinus nerve stimulator.",
      "870.3250-Vascular clip.",
      "870.3260-Vena cava clip.",
      "870.3650-Pacemaker polymeric mesh bag.",
      "870.3450-Vascular graft prosthesis.",
      "870.3610-Implantable pacemaker pulse generator.",
      "870.3720-Pacemaker electrode function tester.",
      "870.3680-Cardiovascular permanent or temporary pacemaker electrode.",
      "868.5830-Autotransfusion apparatus.",
      "870.4100-Extracorporeal circuit and accessories for long-term respiratory/cardiopulmonary failure.",
      "870.2340-Electrocardiograph.",
      "870.2120-Extravascular blood flow probe.",
      "870.2100-Cardiovascular blood flowmeter.",
      "870.2750-Impedance phlebograph.",
      "870.2390-Phonocardiograph.",
      "870.1875-Stethoscope.",
      "870.1230-Fiberoptic oximeter catheter.",
      "870.1360-Trace microsphere.",
      "870.2310-Apex cardiograph (vibrocardiograph).",
      "870.1425-Programmable diagnostic computer.",
      "870.1200-Diagnostic intravascular catheter.",
      "870.1350-Catheter balloon repair kit.",
      "870.1300-Catheter cannula.",
      "870.1370-Catheter tip occluder.",
      "870.1330-Catheter guide wire.",
      "870.1250-Percutaneous catheter.",
      "870.1280-Steerable catheter.",
      "870.1380-Catheter stylet.",
      "870.1390-Trocar.",
      "870.1310-Vessel dilator for percutaneous catheterization.",
      "870.1220-Electrode recording catheter or electrode recording probe.",
      "870.2910-Radiofrequency physiological signal transmitter and receiver.",
      "870.2620-Line isolation monitor.",
      "870.2600-Signal isolation system.",
      "870.5300-DC-defibrillator (including paddles).",
      "870.5325-Defibrillator tester.",
      "870.5200-External cardiac compressor.",
      "870.5225-External counter-pulsating device.",
      "870.5550-External transcutaneous cardiac pacemaker (noninvasive).",
      "870.5925-Automatic rotating tourniquet.",
      "870.2060-Transducer signal amplifier and conditioner.",
      "870.2050-Biopotential amplifier and signal conditioner.",
      "870.2850-Extravascular blood pressure transducer.",
      "870.2300-Cardiac monitor (including cardiotachometer and rate alarm).",
      "870.2350-Electrocardiograph lead switching adaptor.",
      "870.2360-Electrocardiograph electrode.",
      "870.4330-Cardiopulmonary bypass on-line blood gas monitor.",
      "870.2675-Oscillometer.",
      "870.2900-Patient transducer and electrode cable (including connector).",
      "870.2770-Impedance plethysmograph.",
      "870.2810-Paper chart recorder.",
      "870.3690-Pacemaker test magnet.",
      "870.3945-Prosthetic heart valve sizer.",
      "870.3935-Prosthetic heart valve holder.",
      "870.3375-Cardiovascular intravascular filter.",
      "870.4290-Cardiopulmonary bypass adaptor, stopcock, manifold, or fitting.",
      "870.4260-Cardiopulmonary bypass arterial line blood filter.",
      "870.4400-Cardiopulmonary bypass blood reservoir.",
      "870.4230-Cardiopulmonary bypass defoamer.",
      "870.4220-Cardiopulmonary bypass heart-lung machine console.",
      "870.4240-Cardiopulmonary bypass heat exchanger.",
      "870.4420-Cardiopulmonary bypass cardiotomy return sucker.",
      "870.4340-Cardiopulmonary bypass level sensing monitor and/or control.",
      "870.4300-Cardiopulmonary bypass gas control unit.",
      "870.4410-Cardiopulmonary bypass in-line blood gas sensor.",
      "870.4350-Cardiopulmonary bypass oxygenator.",
      "870.4380-Cardiopulmonary bypass pump speed control.",
      "870.4370-Roller-type cardiopulmonary bypass blood pump.",
      "870.4250-Cardiopulmonary bypass temperature controller.",
      "870.4430-Cardiopulmonary bypass intracardiac suction control.",
      "870.4390-Cardiopulmonary bypass pump tubing.",
      "870.4210-Cardiopulmonary bypass vascular catheter, cannula, or tubing.",
      "870.5900-Thermal regulating system.",
      "870.4475-Surgical vessel dilator.",
      "870.4885-External vein stripper.",
      "870.4500-Cardiovascular surgical instruments.",
      "870.4875-Intraluminal artery stripper.",
      "870.4075-Endomyocardial biopsy device.",
      "870.4450-Vascular clamp.",
      "870.5150-Embolectomy catheter.",
      "870.5175-Septostomy catheter.",
      "870.1435-Single-function, preprogrammed diagnostic computer.",
      "870.2920-Telephone electrocardiograph transmitter and receiver.",
      "870.2450-Medical cathode-ray tube display.",
      "870.2330-Echocardiograph.",
      "870.1660-Indicator injector.",
      "870.1450-Densitometer.",
      "870.1130-Noninvasive blood pressure measurement system.",
      "870.2870-Catheter tip pressure transducer.",
      "870.2890-Vessel occlusion transducer.",
      "870.1120-Blood pressure cuff.",
      "870.2320-Ballistocardiograph.",
      "870.4310-Cardiopulmonary bypass coronary pressure gauge.",
      "870.1270-Intracavitary phonocatheter system.",
      "870.1290-Steerable catheter control system.",
      "870.3470-Intracardiac patch or pledget made of polypropylene, polyethylene terephthalate, or polytetrafluoroethylene.",
      "870.1340-Catheter introducer.",
      "870.2400-Vectorcardiograph.",
      "870.3925-Replacement heart valve.",
      "870.1240-Flow-directed catheter.",
      "870.4270-Cardiopulmonary bypass cardiotomy suction line blood filter.",
      "870.2780-Hydraulic, pneumatic, or photoelectric plethysmographs.",
      "870.2840-Apex cardiographic transducer.",
      "870.2860-Heart sound transducer.",
      "870.2880-Ultrasonic transducer.",
      "870.1750-External programmable pacemaker pulse generator.",
      "870.4320-Cardiopulmonary bypass pulsatile flow generator.",
      "870.5800-Compressible limb sleeve.",
      "870.3710-Pacemaker repair or replacement material.",
      "870.4360-Nonroller-type blood pump.",
      "870.1210-Continuous flush catheter.",
      "870.1915-Thermodilution probe.",
      "870.2370-Electrocardiograph surface electrode tester.",
      "870.3300-Vascular embolization device.",
      "870.3640-Indirect pacemaker generator function analyzer.",
      "870.3670-Pacemaker charger.",
      "870.3700-Pacemaker programmers.",
      "870.3800-Annuloplasty ring.",
      "870.4200-Cardiopulmonary bypass accessory equipment.",
      "870.4280-Cardiopulmonary prebypass filter.",
      "870.1140-Venous blood pressure manometer.",
      "870.4205-Cardiopulmonary bypass bubble detector.",
      "870.5210-Cardiopulmonary resuscitation (CPR) aid.",
      "870.5100-Percutaneous Transluminal Coronary Angioplasty (PTCA) Catheter.",
      "870.1650-Angiographic injector and syringe.",
      "870.1670-Syringe actuator for an injector.",
      "870.2700-Oximeter.",
      "870.2855-Implantable Intra-aneurysm Pressure Measurement System.",
      "870.1255-Balloon aortic valvuloplasty catheter.",
      "870.3545-Ventricular bypass (assist) device.",
      "870.3460-Endovascular Suturing System.",
      "870.4510-Apical closure device.",
      "870.2200-Adjunctive cardiovascular status indicator.",
      "870.1252-Percutaneous catheter for creation of an arteriovenous fistula for hemodialysis access.",
      "870.4600",
      "870.1251-Temporary catheter for embolic protection during transcatheter intracardiac procedures.",
      "870.3605-Pacing system analyzer.",
      "870.2210-Adjunctive predictive cardiovascular indicator.",
      "870.2345-Electrocardiograph software for over-the-counter use.",
      "870.2790-Photoplethysmograph analysis software for over-the-counter use.",
      "870.1415-Coronary vascular physiologic simulation software device.",
      "870.5700-Steerable cardiac ablation catheter remote control system.",
      "870.5910-Esophageal thermal regulation device.",
      "870.1345-Intravascular bleed monitor.",
      "870.1342-Reverse central venous recanalization system.",
      "870.2785-Software for optical camera-based measurement of pulse rate, heart rate, breathing rate, and/or respiratory rate.",
      "870.5600-Adjunctive open loop fluid therapy recommender.",
      "870.1420-Coronary artery disease risk indicator using acoustic heart signals.",
      "870.2220-Adjunctive hemodynamic indicator with decision point.",
      "870.4150-Extracorporeal system for carbon dioxide removal.",
      "870.2786-Hardware and software for optical camera-based measurement of pulse rate, heart rate, breathing rate, and/or respiratory rate.",
      "870.1405-Interventional cardiovascular implant simulation software device.",
      "870.5125",
      "870.3955",
      "870.2380",
      "870.5710",
      "870.5720",
      "870.1135",
      "870.2705",
      "870.3325",
      "870.3490",
      "870.1254",
      "880.6305-Ingestible event marker.",
      "892.2050-Medical image management and processing system.",
      "878.4650",
      "878.4400-Electrosurgical cutting and coagulation device and accessories.",
      "878.4300-Implantable clip.",
      "(blank)",
    ],
  },
  {
    label: "Radiology",
    value: "RA",
    regCodes: [
      "892.1950-Radiographic anthropomorphic phantom.",
      "892.1940-Radiologic quality assurance instrument.",
      "892.5710-Radiation therapy beam-shaping block.",
      "892.1910-Radiographic grid.",
      "872.1830-Cephalometer.",
      "872.1850-Lead-lined position indicator.",
      "872.1810-Intraoral source x-ray system.",
      "872.1840-Dental x-ray position indicating device.",
      "872.1800-Extraoral source x-ray system.",
      "892.1630-Electrostatic x-ray imaging system.",
      "892.1670-Spot-film device.",
      "892.1970-Radiographic ECG/respirator synchronizer.",
      "892.1980-Radiologic table.",
      "876.5210-Enema kit.",
      "884.2980-Telethermographic system.",
      "884.2982-Liquid crystal thermographic system.",
      "884.2660-Fetal ultrasonic monitor and accessories.",
      "892.6500-Personnel protective shield.",
      "892.1960-Radiographic intensifying screen.",
      "892.1900-Automatic radiographic film processor.",
      "892.1820-Pneumoencephalographic chair.",
      "892.1570-Diagnostic ultrasonic transducer.",
      "892.1760-Diagnostic x-ray tube housing assembly.",
      "892.5930-Therapeutic x-ray tube housing assembly.",
      "892.5730-Radionuclide brachytherapy source.",
      "892.5750-Radionuclide radiation therapy system.",
      "892.5780-Light beam patient position indicator.",
      "892.5740-Radionuclide teletherapy source.",
      "892.5650-Manual radionuclide applicator system.",
      "892.5050-Medical charged-particle radiation therapy system.",
      "892.5300-Medical neutron radiation therapy system.",
      "892.1920-Radiographic head holder.",
      "892.1840-Radiographic film.",
      "892.1850-Radiographic film cassette.",
      "892.1890-Radiographic film illuminator.",
      "892.1400-Nuclear sealed calibration source.",
      "892.1880-Wall-mounted radiographic cassette holder.",
      "892.1770-Diagnostic x-ray tube mount.",
      "892.5900-X-ray radiation therapy system.",
      "892.1550-Ultrasonic pulsed doppler imaging system.",
      "892.1560-Ultrasonic pulsed echo imaging system.",
      "892.1370-Nuclear anthropomorphic phantom.",
      "892.1380-Nuclear flood source phantom.",
      "892.1390-Radionuclide rebreathing system.",
      "892.1300-Nuclear rectilinear scanner.",
      "892.1100-Scintillation (gamma) camera.",
      "892.1410-Nuclear electrocardiograph synchronizer.",
      "892.1350-Nuclear scanning bed.",
      "892.1110-Positron camera.",
      "892.1320-Nuclear uptake probe.",
      "892.1740-Tomographic x-ray system.",
      "892.1730-Photofluorographic x-ray system.",
      "892.1710-Mammographic x-ray system.",
      "892.1600-Angiographic x-ray system.",
      "892.1620-Cine or spot fluorographic x-ray camera.",
      "892.1720-Mobile x-ray system.",
      "892.1700-Diagnostic x-ray high voltage generator.",
      "892.1870-Radiographic film/cassette changer programmer.",
      "892.1610-Diagnostic x-ray beam-limiting device.",
      "892.1650-Image-intensified fluoroscopic x-ray system.",
      "892.1660-Non-image-intensified fluoroscopic x-ray system.",
      "892.1640-Radiographic film marking system.",
      "892.1540-Nonfetal ultrasonic monitor.",
      "892.5770-Powered radiation therapy patient support assembly.",
      "892.1750-Computed tomography x-ray system.",
      "892.1330-Nuclear whole body scanner.",
      "892.1130-Nuclear whole body counter.",
      "892.1220-Fluorescent scanner.",
      "892.5700-Remote controlled radionuclide applicator system.",
      "892.1420-Radionuclide test pattern phantom.",
      "892.1310-Nuclear tomography system.",
      "892.1170-Bone densitometer.",
      "892.5840-Radiation therapy simulation system.",
      "892.1680-Stationary x-ray system.",
      "892.1200-Emission computed tomography system.",
      "892.1360-Radionuclide dose calibrator.",
      "892.1860-Radiographic film/cassette changer.",
      "892.1830-Radiologic patient cradle.",
      "892.1990-Transilluminator for breast evaluation.",
      "892.2050-Medical image management and processing system.",
      "892.2030-Medical image digitizer.",
      "892.2010-Medical image storage device.",
      "892.2040-Medical image hardcopy device.",
      "892.2020-Medical image communications device.",
      "892.1000-Magnetic resonance diagnostic device.",
      "892.1180-Bone sonometer.",
      "892.1715-Full-field digital mammography system.",
      "892.2070-Medical image analyzer.",
      "892.5720-Rectal balloon for prostate immobilization.",
      "892.5725-Absorbable perirectal spacer.",
      "892.1001",
      "892.6510",
      "892.2060-Radiological computer-assisted diagnostic software for lesions suspicious of cancer.",
      "892.2080-Radiological computer aided triage and notification software.",
      "892.2090",
      "892.2100",
      "892.5785",
      "892.5727",
      "892.5060",
      "892.2055",
      "892.2085",
      "892.5735",
      "892.2052",
      "892.1171",
      "(blank)",
    ],
  },
  {
    label: "Physical Medicine",
    value: "PM",
    regCodes: [
      "890.3910-Wheelchair accessory.",
      "890.3920-Wheelchair component.",
      "890.3940-Wheelchair platform scale.",
      "890.3930-Wheelchair elevator.",
      "890.3800-Motorized three-wheeled vehicle.",
      "890.3690-Powered wheeled stretcher.",
      "882.5860-Implanted neuromuscular stimulator.",
      "890.3050-External compression device for internal jugular vein compression.",
      "890.5420-Electroencephalography (EEG)-driven upper extremity powered exerciser.",
      "890.3100-Mechanical chair.",
      "882.5890-Transcutaneous electrical nerve stimulator for pain relief.",
      "890.5800-Virtual reality behavioral therapy device for pain relief.",
      "882.5804",
      "888.5890-Noninvasive traction component.",
      "890.5380-Powered exercise equipment.",
      "890.5525-Iontophoresis device.",
      "890.5275-Microwave diathermy.",
      "890.1175-Electrode cable.",
      "890.1615-Miniature pressure transducer.",
      "890.1925-Isokinetic testing and evaluation system.",
      "890.1450-Powered reflex hammer.",
      "890.1225-Chronaximeter.",
      "890.5050-Daily activity assist device.",
      "890.5225-Powered patient rotation bed.",
      "890.3475-Limb orthosis.",
      "890.3640-Arm sling.",
      "890.5100-Immersion hydrobath.",
      "890.5150-Powered patient transport.",
      "890.5720-Water circulating hot or cold pack.",
      "890.3700-Nonpowered communication system.",
      "890.3710-Powered communication system.",
      "890.5290-Shortwave diathermy.",
      "890.5500-Infrared lamp.",
      "890.5925-Traction accessory.",
      "890.5730-Moist heat pack.",
      "890.5250-Moist steam cabinet.",
      "890.5110-Paraffin bath.",
      "890.5710-Hot or cold disposable pack.",
      "890.5700-Cold pack.",
      "890.5940-Chilling unit.",
      "890.5860-Ultrasound and muscle stimulator.",
      "890.5300-Ultrasonic diathermy.",
      "890.3110-Electric positioning chair.",
      "890.3790-Cane, crutch, and walker tips and pads.",
      "890.3760-Powered table.",
      "890.3520-Plinth.",
      "890.3750-Mechanical table.",
      "890.5160-Air-fluidized bed.",
      "890.5180-Manual patient rotation bed.",
      "890.5350-Exercise component.",
      "890.5370-Nonmeasuring exercise equipment.",
      "890.5170-Powered flotation therapy bed.",
      "890.3850-Mechanical wheelchair.",
      "890.3665-Congenital hip dislocation abduction splint.",
      "890.5850-Powered muscle stimulator.",
      "890.3025-Prosthetic and orthotic accessory.",
      "890.3900-Standup wheelchair.",
      "890.3610-Rigid pneumatic structure orthosis.",
      "890.3150-Crutch.",
      "890.3075-Cane.",
      "890.3490-Truncal orthosis.",
      "890.3725-Powered environmental control system.",
      "890.3880-Special grade wheelchair.",
      "890.3420-External limb prosthetic component.",
      "890.5575-Powered external limb overload warning device.",
      "890.5975-Therapeutic vibrator.",
      "890.5650-Powered inflatable tube massager.",
      "890.5950-Powered heating unit.",
      "890.5740-Powered heating pad.",
      "890.5660-Therapeutic massager.",
      "890.1850-Diagnostic muscle stimulator.",
      "890.5360-Measuring exercise equipment.",
      "890.3500-External assembled lower limb prosthesis.",
      "890.3410-External limb orthotic component.",
      "890.5900-Power traction equipment.",
      "890.3860-Powered wheelchair.",
      "890.3825-Mechanical walker.",
      "890.3675-Denis Brown splint.",
      "890.5410-Powered finger exerciser.",
      "890.5880-Multi-function physical therapy table.",
      "890.1600-Intermittent pressure measurement system.",
      "890.1575-Force-measuring platform.",
      "890.3175-Flotation cushion.",
      "890.5765-Pressure-applying device.",
      "890.5125-Nonpowered sitz bath.",
      "890.1375-Diagnostic electromyograph.",
      "890.5670-Internal therapeutic massager.",
      "890.3450-Upper extremity prosthesis including a simultaneously powered elbow and/or shoulder with greater than two simultaneous powered degrees of freedom and controlled by non-implanted electrical components.",
      "890.5851",
      "(blank)",
    ],
  },
  {
    label: "General Hospital",
    value: "HO",
    regCodes: [
      "876.1500-Endoscope and accessories.",
      "876.5980-Gastrointestinal tube and accessories.",
      "880.5950-Umbilical occlusion device.",
      "868.5260-Breathing circuit bacterial filter.",
      "868.5120-Anesthesia conduction catheter.",
      "868.5240-Anesthesia breathing circuit.",
      "870.1670-Syringe actuator for an injector.",
      "870.1800-Withdrawal-infusion pump.",
      "870.1650-Angiographic injector and syringe.",
      "870.2750-Impedance phlebograph.",
      "872.6855-Manual toothbrush.",
      "880.6730-Body waste receptacle.",
      "876.5665-Water purification system for hemodialysis.",
      "876.5860-High permeability hemodialysis system.",
      "880.6760-Protective restraint.",
      "880.5440-Intravascular administration set.",
      "880.5580-Acupuncture needle.",
      "880.6740-Vacuum-powered body fluid suction apparatus.",
      "880.2460-Electrically powered spinal fluid pressure monitor.",
      "880.5780-Medical support stocking.",
      "880.6880-Steam sterilizer.",
      "880.6860-Ethylene oxide gas sterilizer.",
      "880.6150-Ultrasonic cleaner for medical instruments.",
      "880.6800-Washers for body waste receptacles.",
      "880.6100-Ethylene oxide gas aerator cabinet.",
      "880.2920-Clinical mercury thermometer.",
      "880.2910-Clinical electronic thermometer.",
      "880.2420-Electronic monitor for gravity flow infusion systems.",
      "880.6230-Tongue depressor.",
      "880.6250-Non-powdered patient examination glove.",
      "880.6265-Examination gown.",
      "880.5860-Piston syringe.",
      "880.5570-Hypodermic single lumen needle.",
      "880.2500-Spinal fluid manometer.",
      "880.6140-Medical chair and table.",
      "880.6450-Skin pressure protectors.",
      "880.6785-Manual patient transfer device.",
      "880.5140-Pediatric medical crib.",
      "880.5130-Infant radiant warmer.",
      "880.6190-Mattress cover for medical purposes.",
      "880.5400-Neonatal incubator.",
      "880.5500-AC-powered patient lift.",
      "880.5120-Manual adjustable hospital bed.",
      "880.5110-Hydraulic adjustable hospital bed.",
      "880.5100-AC-powered adjustable hospital bed.",
      "880.5550-Alternating pressure air flotation mattress.",
      "880.5640-Lamb feeding nipple.",
      "880.6080-Cardiopulmonary resuscitation board.",
      "880.5560-Temperature regulated water mattress.",
      "880.5270-Neonatal eye pad.",
      "880.5200-Intravascular catheter.",
      "880.6990-Infusion stand.",
      "880.6085-Hot/cold water bottle.",
      "880.5410-Neonatal transport incubator.",
      "880.6910-Wheeled stretcher.",
      "880.6900-Hand-carried stretcher.",
      "880.6070-Bed board.",
      "880.2740-Surgical sponge scale.",
      "880.5475-Jet lavage.",
      "880.5820-Therapeutic scrotal support.",
      "880.5160-Therapeutic medical binder.",
      "880.5075-Elastic bandage.",
      "880.2900-Clinical color change thermometer.",
      "880.6500-Medical ultraviolet air purifier.",
      "880.2800-Sterilization process indicator.",
      "880.5045-Medical recirculating air cleaner.",
      "880.6850-Sterilization wrap.",
      "880.2700-Stand-on patient scale.",
      "880.5300-Medical absorbent fiber.",
      "880.5725-Infusion pump.",
      "880.5680-Pediatric position holder.",
      "880.5450-Patient care reverse isolation chamber.",
      "880.2720-Patient scale.",
      "880.6775-Powered patient transfer device.",
      "880.5510-Non-AC-powered patient lift.",
      "880.5630-Nipple shield.",
      "880.5150-Nonpowered flotation therapy mattress.",
      "880.6820-Medical disposable scissors.",
      "880.6185-Cast cover.",
      "880.6060-Medical disposable bedding.",
      "880.6710-Medical ultraviolet water purifier.",
      "880.6870-Dry-heat sterilizer.",
      "880.2400-Bed-patient monitor.",
      "880.6375-Patient lubricant.",
      "880.5210-Intravascular catheter securement device.",
      "880.2200-Liquid crystal forehead temperature strip.",
      "880.5025-I.V. container.",
      "880.6025-Absorbent tipped applicator.",
      "880.6992-Medical washer-disinfector.",
      "880.6885-Liquid chemical sterilants/high level disinfectants.",
      "880.5740-Suction snakebite kit.",
      "880.5760-Chemical cold pack snakebite kit.",
      "880.6050-Ice bag.",
      "880.6280-Medical insole.",
      "880.6350-Battery-powered medical examination light.",
      "880.6430-Liquid medication dispenser.",
      "880.6960-Irrigating syringe.",
      "880.6970-Liquid crystal vein locator.",
      "880.5420-Pressure infusor for an I.V. bag.",
      "880.5430-Nonelectrically powered fluid injector.",
      "880.6320-AC-powered medical examination light.",
      "880.6920-Syringe needle introducer.",
      "880.5700-Neonatal phototherapy unit.",
      "880.6980-Vein stabilizer.",
      "880.6991-Medical washer.",
      "880.2930-Apgar timer.",
      "880.5960-Lice removal kit.",
      "880.5970-Percutaneous, implanted, long-term intravascular catheter.",
      "880.5965-Subcutaneous, implanted, intravascular infusion port and catheter.",
      "880.6890-General purpose disinfectants.",
      "880.6855",
      "880.2915",
      "880.2801",
      "880.5220-Intravenous catheter force-activated separation device.",
      "880.5690",
      "880.2806",
      "880.6886",
      "880.5405",
      "880.6510",
      "880.6993",
      "880.6511",
      "880.6930",
      "882.5550-Central nervous system fluid shunt and components.",
      "864.3250-Specimen transport and storage container.",
      "890.5050-Daily activity assist device.",
      "890.5950-Powered heating unit.",
      "892.1570-Diagnostic ultrasonic transducer.",
      "878.4370-Surgical drape and drape accessories.",
      "878.5070-Air-handling apparatus for a surgical operating room.",
      "878.4040-Surgical apparel.",
      "878.3910-Noninflatable extremity splint.",
      "878.4460-Non-powdered surgeon's glove.",
      "878.4470-Surgeon's gloving cream.",
      "878.4380-Drape adhesive.",
      "878.4960-Operating tables and accessories and operating chairs and accessories.",
      "878.4014-Nonresorbable gauze/sponge for external use.",
      "878.4800-Manual surgical instrument for general use.",
      "878.5050-Surgical smoke precipitator.",
      "878.5080-Air-handling apparatus accessory.",
      "(blank)",
    ],
  },
  {
    label: "Toxicology",
    value: "MG",
    regCodes: [
      "864.1861",
      "866.5980",
      "866.6120",
      "866.5910-Quality control material for cystic fibrosis nucleic acid assays.",
      "(blank)",
    ],
  },
  {
    label: "General and Plastic Surgery",
    value: "SU",
    regCodes: [
      "878.4580-Surgical lamp.",
      "878.3800-External aesthetic restoration prosthesis.",
      "878.3750-External prosthesis adhesive.",
      "878.4200-Introduction/drainage catheter and accessories.",
      "878.4950-Manual operating table and accessories and manual operating chair and accessories.",
      "868.1890-Predictive pulmonary-function value calculator.",
      "870.2700-Oximeter.",
      "874.3620-Ear, nose, and throat synthetic polymer material.",
      "876.5970-Hernia support.",
      "876.5980-Gastrointestinal tube and accessories.",
      "876.5090-Suprapubic urological catheter and accessories.",
      "876.1500-Endoscope and accessories.",
      "876.1075-Gastroenterology-urology biopsy instrument.",
      "876.4300-Endoscopic electrosurgical unit and accessories.",
      "880.5240-Medical adhesive tape and adhesive bandage.",
      "880.5180-Burn sheet.",
      "878.4740-Surgical stapler.",
      "880.5090-Liquid bandage.",
      "880.5200-Intravascular catheter.",
      "880.2740-Surgical sponge scale.",
      "880.5075-Elastic bandage.",
      "880.2750-Image processing device for estimation of external blood loss.",
      "882.4560-Stereotaxic instrument.",
      "890.5660-Therapeutic massager.",
      "890.5500-Infrared lamp.",
      "890.5740-Powered heating pad.",
      "892.1560-Ultrasonic pulsed echo imaging system.",
      "892.1710-Mammographic x-ray system.",
      "878.4780-Powered suction pump.",
      "878.3910-Noninflatable extremity splint.",
      "878.4400-Electrosurgical cutting and coagulation device and accessories.",
      "878.4040-Surgical apparel.",
      "878.4820-Surgical instrument motors and accessories/attachments.",
      "878.4800-Manual surgical instrument for general use.",
      "878.4700-Surgical microscope and accessories.",
      "878.1800-Speculum and accessories.",
      "878.3500-Polytetrafluoroethylene with carbon fibers composite implant material.",
      "878.4014-Nonresorbable gauze/sponge for external use.",
      "878.5900-Nonpneumatic tourniquet.",
      "878.3300-Surgical mesh.",
      "878.4350-Cryosurgical unit and accessories.",
      "878.4960-Operating tables and accessories and operating chairs and accessories.",
      "878.4850-Blood lancets.",
      "878.4370-Surgical drape and drape accessories.",
      "878.4630-Ultraviolet lamp for dermatologic disorders.",
      "878.4160-Surgical camera and accessories.",
      "878.3925-Plastic surgery kit and accessories.",
      "878.3540-Silicone gel-filled breast prosthesis.",
      "878.3530-Silicone inflatable breast prosthesis.",
      "878.3550-Chin prosthesis.",
      "878.3250-External facial fracture fixation appliance.",
      "878.3590-Ear prosthesis.",
      "878.3680-Nose prosthesis.",
      "878.3900-Inflatable extremity splint.",
      "878.5070-Air-handling apparatus for a surgical operating room.",
      "878.4300-Implantable clip.",
      "878.4320-Removable skin clip.",
      "878.4660-Skin marker.",
      "878.4830-Absorbable surgical gut suture.",
      "878.4493-Absorbable poly(glycolide/l-lactide) surgical suture.",
      "878.4495-Stainless steel suture.",
      "878.5030-Natural nonabsorbable silk surgical suture.",
      "878.5020-Nonabsorbable polyamide surgical suture.",
      "878.5000-Nonabsorbable poly(ethylene terephthalate) surgical suture.",
      "878.5010-Nonabsorbable polypropylene surgical suture.",
      "878.4680-Nonpowered, single patient, portable suction apparatus.",
      "878.4760-Removable skin staple.",
      "878.4750-Implantable staple.",
      "878.4450-Nonabsorbable gauze for internal use.",
      "878.4810-Laser surgical instrument for use in general and plastic surgery and in dermatology.",
      "878.4440-Eye pad.",
      "878.3610-Esophageal prosthesis.",
      "878.5350-Needle-type epilator.",
      "878.5360-Tweezer-type epilator.",
      "878.5910-Pneumatic tourniquet.",
      "878.4590-Focused ultrasound stimulator system for aesthetic use.",
      "878.4018-Hydrophilic wound dressing.",
      "878.5650-Topical oxygen chamber for extremities.",
      "878.4635-Sunlamp products and ultraviolet lamps intended for use in sunlamp products.",
      "878.4490-Absorbable hemostatic agent and dressing.",
      "878.4100-Organ bag.",
      "878.4730-Surgical skin degreaser or adhesive tape solvent.",
      "878.4010-Tissue adhesive.",
      "878.4020-Occlusive wound dressing.",
      "878.5040-Suction lipoplasty system.",
      "878.4494-Absorbable poly(hydroxybutyrate) surgical suture produced by recombinant DNA technology.",
      "878.4015-Wound dressing with poly (diallyl dimethyl ammonium chloride) (pDADMAC) additive.",
      "878.3720-Tracheal prosthesis.",
      "878.4815-Magnetic surgical instrument system.",
      "878.4454-Non-absorbable, hemostatic gauze for temporary internal use.",
      "878.4371-Irrigating wound retractor device.",
      "878.3510-Carbon dioxide gas controlled tissue expander.",
      "878.4805-Manual percutaneous surgical set assembled in the abdomen.",
      "878.4420-Electrosurgical device for over-the-counter aesthetic use.",
      "878.4024",
      "878.4670-Internal tissue marker.",
      "878.4452-Nonabsorbable expandable hemostatic sponge for temporary internal use.",
      "878.4360-Scalp cooling system to reduce the likelihood of chemotherapy-induced alopecia.",
      "878.4430-Microneedling device for aesthetic use.",
      "878.4456-Hemostatic device for intraluminal gastrointestinal use.",
      "878.4165-Wound autofluorescence imaging device.",
      "878.4550-Autofluorescence detection device for general surgery and dermatological use.",
      "878.4783-Negative pressure wound therapy device for reduction of wound complications.",
      "878.4405",
      "878.4835",
      "878.4961-Mountable electromechanical surgical system for transluminal approaches.",
      "878.4880",
      "878.4675",
      "878.4425",
      "878.4795",
      "878.1830",
      "878.4825-General laparoscopic power morcellation containment system.",
      "878.4816",
      "878.4962",
      "878.4963",
      "878.4964",
      "878.4965",
      "(blank)",
    ],
  },
  {
    label: "Dental Part",
    value: "DE",
    regCodes: [
      "872.4120-Bone cutting instrument and accessories.",
      "872.4880-Intraosseous fixation screw or wire.",
      "872.4730-Dental injecting needle.",
      "872.4565-Dental hand instrument.",
      "872.4535-Dental diamond instrument.",
      "872.3110-Dental amalgam capsule.",
      "872.6350-Ultraviolet detector.",
      "872.1730-Electrode gel for pulp testers.",
      "872.1720-Pulp tester.",
      "872.4620-Fiber optic dental light.",
      "872.4630-Dental operating light.",
      "872.3750-Bracket adhesive resin and tooth conditioner.",
      "872.5410-Orthodontic appliance and accessories.",
      "872.6640-Dental operative unit and accessories.",
      "872.5525-Preformed tooth positioner.",
      "872.5470-Orthodontic plastic bracket.",
      "872.4600-Intraoral ligature and wire lock.",
      "872.4130-Intraoral dental drill.",
      "872.5500-Extraoral orthodontic headgear.",
      "872.3640-Endosseous dental implant.",
      "872.3765-Pit and fissure sealant and conditioner.",
      "872.3310-Coating material for resin fillings.",
      "872.3300-Hydrophilic resin coating for dentures.",
      "872.3690-Tooth shade resin material.",
      "872.3770-Temporary crown and bridge resin.",
      "872.3670-Resin impression tray material.",
      "872.3760-Denture relining, repairing, or rebasing resin.",
      "872.3740-Retentive and splinting pin.",
      "872.3570-OTC denture repair kit.",
      "872.3560-OTC denture reliner.",
      "872.4200-Dental handpiece and accessories.",
      "872.6070-Ultraviolet activator for polymerization.",
      "872.6730-Endodontic dry heat sterilizer.",
      "872.6710-Boiling water sterilizer.",
      "872.6200-Base plate shellac.",
      "872.6300-Rubber dam and accessories.",
      "872.6475-Heat source for bleaching teeth.",
      "872.6010-Abrasive device and accessories.",
      "872.6100-Anesthetic warmer.",
      "872.3100-Dental amalgamator.",
      "872.6140-Articulation paper.",
      "872.6050-Saliva absorber.",
      "872.6510-Oral irrigation unit.",
      "872.3520-OTC denture cleanser.",
      "872.6855-Manual toothbrush.",
      "872.6670-Silicate protector.",
      "872.6890-Intraoral dental wax.",
      "872.3165-Precision attachment.",
      "872.4475-Spring-powered jet injector.",
      "872.4465-Gas-powered jet injector.",
      "872.1905-Dental x-ray film holder.",
      "872.1820-Dental x-ray exposure alignment device.",
      "872.3080-Mercury and alloy dispenser.",
      "872.6290-Prophylaxis cup.",
      "872.3285-Preformed clasp.",
      "872.3360-Preformed cusp.",
      "872.3540-OTC denture cushion or pad.",
      "872.6880-Preformed impression tray.",
      "872.6660-Porcelain powder for clinical use.",
      "872.3060-Noble metal alloy.",
      "872.3710-Base metal alloy.",
      "872.6770-Cartridge syringe.",
      "872.3070-Dental amalgam, mercury, and amalgam alloy.",
      "872.3250-Calcium hydroxide cavity liner.",
      "872.3240-Dental bur.",
      "872.3150-Articulator.",
      "872.6030-Oral cavity abrasive polishing agent.",
      "872.3130-Preformed anchor.",
      "872.3840-Endodontic silver point.",
      "872.3850-Gutta percha.",
      "872.3830-Endodontic paper point.",
      "872.3600-Partially fabricated denture kit.",
      "872.4920-Dental electrosurgical unit and accessories.",
      "872.4840-Rotary scaler.",
      "872.4850-Ultrasonic scaler.",
      "872.3645-Subperiosteal implant material.",
      "872.3900-Posterior artificial tooth with a metal insert.",
      "872.3910-Backing and facing for an artificial tooth.",
      "872.3920-Porcelain tooth.",
      "872.3590-Preformed plastic denture tooth.",
      "872.3580-Preformed gold denture tooth.",
      "872.3350-Gold or stainless steel cusp.",
      "872.3810-Root canal post.",
      "872.3890-Endodontic stabilizing splint.",
      "872.3660-Impression material.",
      "872.3330-Preformed crown.",
      "872.3275-Dental cement.",
      "872.1500-Gingival fluid measurer.",
      "872.6865-Powered toothbrush.",
      "872.3530-Mechanical denture cleaner.",
      "872.6390-Dental floss.",
      "872.6650-Massaging pick or tip for oral hygiene.",
      "872.4760-Bone plate.",
      "872.6570-Impression tube.",
      "872.3220-Facebow.",
      "872.3730-Pantograph.",
      "872.3820-Root canal filling resin.",
      "872.5550-Teething ring.",
      "872.6250-Dental chair and accessories.",
      "872.3200-Resin tooth bonding agent.",
      "872.6080-Airbrush.",
      "872.3410-Ethylene oxide homopolymer and/or carboxymethylcellulose sodium denture adhesive.",
      "872.3400-Karaya and sodium borate with or without acacia denture adhesive.",
      "872.3480-Polyacrylamide polymer (modified cationic) denture adhesive.",
      "872.3490-Carboxymethylcellulose sodium and/or polyvinylmethylether maleic acid calcium-sodium double salt denture adhesive.",
      "872.3450-Ethylene oxide homopolymer and/or karaya denture adhesive.",
      "872.3420-Carboxymethylcellulose sodium and cationic polyacrylamide polymer denture adhesive.",
      "872.3140-Resin applicator.",
      "872.3500-Polyvinylmethylether maleic anhydride (PVM-MA), acid copolymer, and carboxymethylcellulose sodium (NACMC) denture adhesive.",
      "872.3661-Optical Impression Systems for CAD/CAM.",
      "872.3260-Cavity varnish.",
      "872.1740-Caries detection device.",
      "872.3930-Bone grafting material.",
      "872.5570-Intraoral devices for snoring and intraoral devices for snoring and obstructive sleep apnea.",
      "872.5560-Electrical salivary stimulatory system.",
      "872.3940-Total temporomandibular joint prosthesis.",
      "872.3980-Endosseous dental implant accessories.",
      "872.3950-Glenoid fossa prosthesis.",
      "872.3970-Interarticular disc prosthesis (interpositional implant).",
      "872.3960-Mandibular condyle prosthesis.",
      "872.1870-Sulfide detection device.",
      "872.1745-Laser fluorescence caries detection device.",
      "872.4770-Temporary mandibular condyle reconstruction plate.",
      "872.3680-Polytetrafluoroethylene (PTFE) vitreous carbon materials.",
      "872.2050-Dental sonography device.",
      "872.2060-Jaw tracking device.",
      "872.3630-Endosseous dental implant abutment.",
      "872.5580-Oral rinse to reduce the adhesion of dental plaque.",
      "872.5571-Auto titration device for oral appliances.",
      "872.6866-Radiofrequency toothbrush.",
      "872.5575-Neuromuscular tongue muscle stimulator for the reduction of snoring and obstructive sleep apnea.",
      "872.5590",
      "872.1770",
      "880.6885-Liquid chemical sterilants/high level disinfectants.",
      "880.6375-Patient lubricant.",
      "890.1375-Diagnostic electromyograph.",
      "890.3475-Limb orthosis.",
      "890.5850-Powered muscle stimulator.",
      "878.4810-Laser surgical instrument for use in general and plastic surgery and in dermatology.",
      "878.4200-Introduction/drainage catheter and accessories.",
      "878.4370-Surgical drape and drape accessories.",
      "(blank)",
    ],
  },
];
export const f1TableResults = {
  D1: { label: "D1 -Actual Device", status: "success" },
  A1: { label: "A1 - Same Use", status: "success" },
  P1: { label: "P1 - Applicable", status: "success" },
  R1: { label: "R1-High quality", status: "success" },
  D2: { label: "D2-Comparable Device", status: "warning" },
  A2: { label: "A2 - Minor deviation", status: "warning" },
  P2: { label: "P2 - Limited", status: "warning" },
  R2: { label: "R2-Minor deficiencies", status: "warning" },
  D3: { label: "D3-Other medical device", status: "error" },
  A3: { label: "A3-Major deviation", status: "error" },
  P3: { label: "P3 - Different population", status: "error" },
  R3: { label: "R3 - Insufficient information", status: "error" },
};

export const f2TableResults = {
  T1: { label: "T1- Yes", status: "success" },
  O1: { label: "O1- Yes", status: "success" },
  F1: { label: "F1- Yes", status: "success" },
  S1: { label: "S1- Yes", status: "success" },
  C1: { label: "C1- Yes", status: "success" },
  T2: { label: "T2- No", status: "error" },
  O2: { label: "O2- No", status: "error" },
  F2: { label: "F2- No", status: "error" },
  S2: { label: "S2- No", status: "error" },
  C2: { label: "C2- No", status: "error" },
};
